export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: string;
  JSON: string;
  JSONObject: any;
};

export type AccreditationInfo = {
  __typename?: 'AccreditationInfo';
  /** Accreditation status */
  accreditationType: AccreditationType;
  /** Country */
  country: Scalars['String'];
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Current status */
  entityStatus: ProjectPublish;
  /** After this date current info is no longer valid. If entity is not accredited, this field can be null */
  expirationDate?: Maybe<Scalars['DateTime']>;
  /** Record unique Id */
  id: Scalars['String'];
  /** Record start date */
  startDate: Scalars['DateTime'];
  /** Status for this info */
  status: InformationStatus;
  /** User legal entity that this accreditation info belongs to */
  userLegalEntity: UserLegalEntity;
  /** User legal entity id */
  userLegalEntityId: Scalars['String'];
};

/** Accreditation type for legal entity */
export enum AccreditationType {
  /** Legal entity is an accredited investor */
  Accredited = 'accredited',
  /** Legal entity is not an accredited investor */
  NonAccredited = 'nonAccredited',
}

export type ActionsEntity = {
  __typename?: 'ActionsEntity';
  /** References to the action to allow better readability of the db records */
  actionRef?: Maybe<Scalars['JSONObject']>;
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Current status */
  entityStatus: ProjectPublish;
  /** Record unique Id */
  id: Scalars['String'];
  /** Date of the action */
  interestedDate?: Maybe<Scalars['DateTime']>;
  offering: Offer;
  /** Id of the offering */
  offeringId: Scalars['String'];
  /** Status of the action for the operator */
  operatorActionStatus?: Maybe<ActionsOperatorStatusEnum>;
  /** Operator id */
  operatorId?: Maybe<Scalars['String']>;
  /** Number of pop ups shown */
  popUpsShown?: Maybe<Scalars['Float']>;
  /** Record start date */
  startDate: Scalars['DateTime'];
  /** Status of the action */
  status: ActionsStatusEnum;
  user: UserObject;
  /** User id */
  userId?: Maybe<Scalars['String']>;
};

/** Actions operator status */
export enum ActionsOperatorStatusEnum {
  /** Actions operator new */
  New = 'new',
  /** Actions operator viewed */
  Viewed = 'viewed',
}

/** Actions status */
export enum ActionsStatusEnum {
  /** Actions active */
  Active = 'active',
  /** Actions dismissed */
  Dismissed = 'dismissed',
  /** Actions interested */
  Interested = 'interested',
  /** Actions viewed */
  Viewed = 'viewed',
}

export type AddLegalEntityToSubAdminInput = {
  /** User legal entity ids */
  legalEntityIds: Array<Scalars['String']>;
  /** The sub admin id */
  subAdminId: Scalars['String'];
};

/** The supported admin Types */
export enum AdminType {
  /** The sub admin with restricted access */
  RestrictedAdmin = 'RESTRICTED_ADMIN',
  /** The super admin with full access */
  SuperAdmin = 'SUPER_ADMIN',
}

export type ApproveAccreditationInfoInput = {
  /** Accreditation info id */
  accreditationInfoId: Scalars['String'];
  /** This info won`t be valid after this date. Not applicable for non-accredited investors */
  expirationDate?: InputMaybe<Scalars['String']>;
};

export type ApproveBankAccountInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['String'];
};

export type ApproveTaxInfoInput = {
  /** Tax info id */
  taxInfoId: Scalars['String'];
};

export type BankAccount = {
  __typename?: 'BankAccount';
  /** Bank identification number. If IBAN is present, all other bank related info is not needed */
  IBAN?: Maybe<Scalars['String']>;
  /** Account name. Required if BIN is missing */
  accountName?: Maybe<Scalars['String']>;
  /** Account number. Required if BIN is missing */
  accountNumber?: Maybe<Scalars['String']>;
  /** Bank account, that this entity is supposed to replace (after accepting changes by operator). */
  approvedBankAccount?: Maybe<BankAccount>;
  /**
   * Link to the bank account, that this entity is supposed to replace after operator accepts changes.
   *     It is important to know, which account investor wants to edit (request changes, to be precise) or whether investor wants to create a new account completely. In an approved account this id is irrelevant
   */
  approvedBankAccountId?: Maybe<Scalars['String']>;
  /** Bank name. Required if BIN is missing */
  bankName?: Maybe<Scalars['String']>;
  /** Bank identification number. If IBAN is present, all other bank related info is not needed */
  benificiaryAddress?: Maybe<Scalars['String']>;
  /** Address of the bank branch. Required if BIN is missing */
  branchAddress?: Maybe<Scalars['String']>;
  /** Number of the bank branch. Required if BIN is missing */
  branchNumber?: Maybe<Scalars['String']>;
  /** the currencies the bank account will be used for. */
  currencies?: Maybe<Array<Scalars['String']>>;
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Current status */
  entityStatus: ProjectPublish;
  /** Record unique Id */
  id: Scalars['String'];
  /** Active status. This bank account will be used by default. Only approved bank account can be active */
  isActive: Scalars['Boolean'];
  /** Text, that only operator can see and edit. */
  notes?: Maybe<Scalars['String']>;
  /** Operator id */
  operatorId?: Maybe<Scalars['String']>;
  /** The routing number */
  routingNumber?: Maybe<Scalars['String']>;
  /** Record start date */
  startDate: Scalars['DateTime'];
  /** Status for this bank account */
  status: InformationStatus;
  /** the swift */
  swift?: Maybe<Scalars['String']>;
  /** User legal entity that this bank account belongs to */
  userLegalEntity: UserLegalEntity;
  /** User legal entity id */
  userLegalEntityId: Scalars['String'];
};

export type BankFileOutput = {
  __typename?: 'BankFileOutput';
  /** Bank account information related to the investor */
  bankAccountInformation: Array<BankAccount>;
  /** Total distribution amount for the investor */
  distributionAmount: Scalars['Float'];
  /** Name of the investor */
  investorName: Scalars['String'];
  /** Unique ID of the investor */
  investorUniqueId: Scalars['String'];
};

export type BarColorInput = {
  /** color */
  barA: Scalars['String'];
  /** color */
  barAOpacity: Scalars['String'];
  /** color */
  barB: Scalars['String'];
  /** color */
  barBOpacity: Scalars['String'];
  /** color */
  barC: Scalars['String'];
  /** color */
  barCOpacity: Scalars['String'];
  /** color */
  barD: Scalars['String'];
  /** color */
  barDOpacity: Scalars['String'];
};

export type BarColorObject = {
  __typename?: 'BarColorObject';
  /** color */
  barA: Scalars['String'];
  /** color */
  barAOpacity: Scalars['String'];
  /** color */
  barB: Scalars['String'];
  /** color */
  barBOpacity: Scalars['String'];
  /** color */
  barC: Scalars['String'];
  /** color */
  barCOpacity: Scalars['String'];
  /** color */
  barD: Scalars['String'];
  /** color */
  barDOpacity: Scalars['String'];
};

/** Project calculatio type. */
export enum CalculationType {
  /** profimex GROSS_COC value from returned from their system. */
  GrossCoc = 'GROSS_COC',
  /** profimex GROSS_IRR value from returned from their system. */
  GrossIrr = 'GROSS_IRR',
  /** profimex GROSS_ROI value from returned from their system. */
  GrossRoi = 'GROSS_ROI',
  /** Calculates the internal rate of return on an investment based on a series of periodic cash flows. */
  Irr = 'IRR',
  /** profimex NET_COC value from returned from their system. */
  NetCoc = 'NET_COC',
  /** profimex NET_IRR value from returned from their system. */
  NetIrr = 'NET_IRR',
  /** profimex NET_ROI value from returned from their system. */
  NetRoi = 'NET_ROI',
  /** total annual return divided by the current equity owned in the property. */
  Roe = 'ROE',
  /** total annual return divided by the original amount invested. */
  Roi = 'ROI',
  /** Calculates the internal rate of return of an investment based on a specified series of potentially irregularly spaced cash flows. */
  Xirr = 'XIRR',
}

export type CategoryColorInput = {
  /** A map of category names to their corresponding colors as an array of key-value pairs */
  colors: Array<KeyValueInput>;
};

export type CategoryColorObject = {
  __typename?: 'CategoryColorObject';
  /** A map of category names to their corresponding colors as an array of key-value pairs */
  colors: Array<KeyValueObject>;
};

export type ColorInput = {
  /** color */
  button: Scalars['String'];
  /** color */
  icons: Scalars['String'];
  /** color */
  primary: Scalars['String'];
  /** color */
  secondary: Scalars['String'];
  /** color */
  selectedIcon: Scalars['String'];
  /** color */
  title: Scalars['String'];
};

export type ColorObject = {
  __typename?: 'ColorObject';
  /** color */
  button: Scalars['String'];
  /** color */
  icons: Scalars['String'];
  /** color */
  primary: Scalars['String'];
  /** color */
  secondary: Scalars['String'];
  /** color */
  selectedIcon: Scalars['String'];
  /** color */
  title: Scalars['String'];
};

export type CreateAccreditationInfoInput = {
  /** Accreditation type */
  accreditationType: AccreditationType;
  /** Residency country */
  country: Scalars['String'];
  /** This info won`t be valid after this date. Not applicable for non-accredited investors */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** User legal entity id */
  userLegalEntityId: Scalars['String'];
};

export type CreateBankAccountInput = {
  /** Bank identification number */
  IBAN?: InputMaybe<Scalars['String']>;
  /** Account name */
  accountName?: InputMaybe<Scalars['String']>;
  /** Account number */
  accountNumber?: InputMaybe<Scalars['String']>;
  /** Bank name */
  bankName?: InputMaybe<Scalars['String']>;
  /** Bank identification number */
  benificiaryAddress?: InputMaybe<Scalars['String']>;
  /** Full address for bank branch */
  branchAddress?: InputMaybe<Scalars['String']>;
  /** Bank branch number */
  branchNumber?: InputMaybe<Scalars['String']>;
  /** the currencies the bank account will be used for. */
  currencies?: InputMaybe<Array<Scalars['String']>>;
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Additional notes, that only operator can see */
  notes?: InputMaybe<Scalars['String']>;
  /** Routing Number /ABA */
  routingNumber?: InputMaybe<Scalars['String']>;
  /** the swift */
  swift?: InputMaybe<Scalars['String']>;
  /** User legal entity id */
  userLegalEntityId: Scalars['String'];
};

export type CreateBankFileInput = {
  /** End date for filtering investment distributions */
  endDate: Scalars['String'];
  /** List of entity IDs (projects or funds) to filter by */
  entitiesIds: Array<Scalars['String']>;
  /** Start date for filtering investment distributions */
  startDate: Scalars['String'];
};

export type CreateFundInput = {
  /** Fund closing date */
  closingDate?: InputMaybe<Scalars['DateTime']>;
  /** Fund currency */
  currency?: InputMaybe<Currency>;
  /** Fund description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Fund investments distribution */
  distributions?: InputMaybe<Array<ProjectPropertyDataInput>>;
  /** Fund inception date */
  inceptionDate?: InputMaybe<Scalars['DateTime']>;
  /** Investment classes for this fund */
  investmentClasses?: InputMaybe<Array<ProjectInvestmentClassesInput>>;
  /** Fund view type layout */
  layout?: InputMaybe<Array<LayoutDataInput>>;
  /** Fund name */
  name?: InputMaybe<Scalars['String']>;
  /** Related operator id */
  operatorId: Scalars['String'];
  /** Project portfolio (for manual entry) */
  portfolio?: InputMaybe<Array<FundPortfolioDataInput>>;
  /** Fund properties ( distributions, assets, rents and et.c.) */
  properties?: InputMaybe<Array<ProjectPropertyInput>>;
  /** Fund status */
  status?: InputMaybe<ProjectStatus>;
};

export type CreateFundProjectInput = {
  /** Project category */
  category?: InputMaybe<ProjectCategory>;
  /** Project currency */
  currency?: InputMaybe<Scalars['String']>;
  /** Project custom category */
  customCategory?: InputMaybe<Scalars['String']>;
  /** Fund project description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Project fund ref */
  fundId: Scalars['String'];
  /** Project view type layout */
  layout?: InputMaybe<Array<LayoutDataInput>>;
  /** Project address location */
  location?: InputMaybe<ProjectLocationInput>;
  /** Project fund name */
  name?: InputMaybe<Scalars['String']>;
  /** Project portfolio (for manual entry) */
  portfolio?: InputMaybe<Array<ProjectPortfolioDataInput>>;
  /** Operator linked project */
  projectId?: InputMaybe<Scalars['String']>;
};

export type CreateInvestmentInput = {
  /** Investment amount */
  amount?: InputMaybe<Scalars['Float']>;
  /** Investment commitment */
  commitment?: InputMaybe<Scalars['Float']>;
  /** Investment Contributions */
  contributions?: InputMaybe<Array<InvestmentContributionsInput>>;
  /** Investment Version */
  customizedStatistics?: InputMaybe<Array<StatisticsKeyValueInput>>;
  /** Investment date */
  date?: InputMaybe<Scalars['DateTime']>;
  /** Investment description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Investment Distributions */
  distributions?: InputMaybe<Array<InvestmentDistributionsInput>>;
  /** Defines the existing investor id and whether this is an existing investor (no need to update the investor legal entity) */
  existingInvestorId?: InputMaybe<Scalars['String']>;
  /** Investment exit date */
  exitDate?: InputMaybe<Scalars['DateTime']>;
  /** Invested by legal entity name (legal entity will be renamed if legalEntityUniqueId is matching some legal entity) */
  investedBy?: InputMaybe<Scalars['String']>;
  /** Investment class name */
  investmentClassName?: InputMaybe<Scalars['String']>;
  /** Investors emails (when updating this field investors won`t be removed => only new investors can be created). In order to update investors email for legal entity, updateLegalEntity mutation should be called */
  investorEmails?: InputMaybe<Array<Scalars['String']>>;
  /** Defines investment as contribution */
  isContribution?: InputMaybe<Scalars['Boolean']>;
  /** Invested by legal entity (Unique ID) */
  legalEntityUniqueId?: InputMaybe<Scalars['String']>;
  /** Investment holdings which was added manually for custom calculations */
  manualHoldings?: InputMaybe<Array<InvestmentHoldingInput>>;
  /** Investor operator name */
  name?: InputMaybe<Scalars['String']>;
  /** Investment operator unique Id */
  operatorId: Scalars['String'];
  /** Investment percentage */
  percentage?: InputMaybe<Scalars['Float']>;
  /** Investment period time in months */
  period?: InputMaybe<Scalars['Float']>;
  /** Investor operator phone */
  phone?: InputMaybe<Scalars['String']>;
  /** Investment reference to project/fund */
  ref: Array<InvestmentRefInput>;
  /** Investment sequence id */
  sequenceId?: InputMaybe<Scalars['Float']>;
  /** Investment type */
  type?: InputMaybe<InvestmentType>;
  /** Investment Version */
  version?: InputMaybe<Scalars['Float']>;
  /** Viewer emails */
  viewerEmails?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateOfferInput = {
  /** audience for getting the offering */
  audience?: InputMaybe<Array<ProspectInput>>;
  /** Offer category */
  category?: InputMaybe<ProjectCategory>;
  /** Offer currency */
  currency?: InputMaybe<Currency>;
  /** Offer custom category */
  customCategory?: InputMaybe<Scalars['String']>;
  /** Offering description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** freely defined key value kpi the offering */
  kpis?: InputMaybe<Array<OfferKpiInput>>;
  /** Offer address location */
  location?: InputMaybe<ProjectLocationInput>;
  /** Offer name */
  name?: InputMaybe<Scalars['String']>;
  /** Offer publish date */
  offerPublishDate?: InputMaybe<Scalars['DateTime']>;
  /** Offer start date */
  offerStartDate?: InputMaybe<Scalars['DateTime']>;
  /** Related operator id */
  operatorId: Scalars['String'];
  /** Offer status */
  status?: InputMaybe<OfferingStatusEnum>;
  /** Offer strategy */
  strategy?: InputMaybe<Scalars['String']>;
  /** Offer view mode */
  viewMode?: InputMaybe<ViewMode>;
};

export type CreateOperatorAdminInput = {
  /** the contact link */
  contactLink?: InputMaybe<Scalars['String']>;
  /** the email */
  email?: InputMaybe<Scalars['String']>;
  /** the first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** the first name */
  lastName?: InputMaybe<Scalars['String']>;
  /** the phone number */
  phone?: InputMaybe<Scalars['String']>;
  /** The role */
  role?: InputMaybe<AdminType>;
};

export type CreateOperatorInput = {
  /** Operator contact list */
  contacts?: InputMaybe<Array<OperatorContactsInput>>;
  /** Operator description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Operator view type layout */
  layout?: InputMaybe<Array<LayoutDataInput>>;
  /** Operator official name */
  name?: InputMaybe<Scalars['String']>;
  /** Operator users */
  users: Array<Scalars['String']>;
  /** Operator website address */
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type CreateOperatorProjectInput = {
  /** Project calculation type */
  calculationType?: InputMaybe<CalculationType>;
  /** Project category */
  category?: InputMaybe<ProjectCategory>;
  /** Project end date */
  closingDate?: InputMaybe<Scalars['DateTime']>;
  /** Project currency */
  currency?: InputMaybe<Currency>;
  /** Project custom category */
  customCategory?: InputMaybe<Scalars['String']>;
  /** Project description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Project investments distribution */
  distributions?: InputMaybe<Array<ProjectPropertyDataInput>>;
  /** Project start date */
  inceptionDate?: InputMaybe<Scalars['DateTime']>;
  /** Investment classes for this project */
  investmentClasses?: InputMaybe<Array<ProjectInvestmentClassesInput>>;
  /** Project view type layout */
  layout?: InputMaybe<Array<LayoutDataInput>>;
  /** Project address location */
  location?: InputMaybe<ProjectLocationInput>;
  /** Project name */
  name: Scalars['String'];
  /** Project operator ref */
  operatorId: Scalars['String'];
  /** Project portfolio (for manual entry) */
  portfolio?: InputMaybe<Array<ProjectPortfolioDataInput>>;
  /** Project cancelation date */
  projectCancellationDate?: InputMaybe<Scalars['DateTime']>;
  /** Project properties ( distributions, assets, rents and et.c.) */
  properties?: InputMaybe<Array<ProjectPropertyInput>>;
  /** Project status */
  status: ProjectStatus;
};

export type CreateTaxInfoInput = {
  /** Social security number */
  SSN?: InputMaybe<Scalars['String']>;
  /** Tax identification number */
  TIN?: InputMaybe<Scalars['String']>;
  /** Full address for this legal entity */
  address?: InputMaybe<Scalars['String']>;
  /** Additional notes, that only operator can see */
  notes?: InputMaybe<Scalars['String']>;
  /** User legal entity id */
  userLegalEntityId: Scalars['String'];
};

export type CreateUpdatesInput = {
  /** Update description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Update display flag for timeline */
  displayTimeline?: InputMaybe<Scalars['Boolean']>;
  /** the operatorId */
  operatorId?: InputMaybe<Scalars['String']>;
  /** Update progress */
  progress?: InputMaybe<Scalars['Float']>;
  /** Update reference (operatorId or projectId) */
  ref: UpdateRefInput;
  /** Update report date */
  reportDate?: InputMaybe<Scalars['DateTime']>;
  /** Update status */
  status?: InputMaybe<Scalars['String']>;
  /** Multi language title */
  title?: InputMaybe<MultiLanObjectInput>;
};

export type CreateUserInput = {
  /** User email */
  email: Scalars['String'];
  /** User firstname */
  firstName?: InputMaybe<Scalars['String']>;
  /** User profile image */
  imgUrl?: InputMaybe<Scalars['String']>;
  /** User preffered language */
  language?: InputMaybe<Language>;
  /** User lastname */
  lastName?: InputMaybe<Scalars['String']>;
  /** User role */
  role: UserRoles;
  /** User settings */
  settings?: InputMaybe<UserSettingsInput>;
};

export type CreateUserLegalEntityInput = {
  /**
   * Users with provided emails will be added to investors array.
   *       If some users do not exist in the system, they will be created.
   *       Legal entity cannot have investors and prospects at the same time, so if this field is present then prospectEmails should be empty
   */
  investorEmails: Array<Scalars['String']>;
  /** User legal entity name */
  name: Scalars['String'];
  /** Operator id. This field is only required by an admin user. Otherwise current user operator ID will be assigned to newly created legal entity */
  operatorID?: InputMaybe<Scalars['String']>;
  /**
   * Users with provided emails will be added to prospects array.
   *       If some users do not exist in the system, they will be created.
   *       Legal entity cannot have prospects and viewers/investors at the same time, so if this field is present then investorEmails and viewerEmails should be empty
   */
  prospectEmails: Array<Scalars['String']>;
  /** User legal entity unique identifier */
  uniqueId: Scalars['String'];
  /**
   * Users with provided emails will be added to viewers array.
   *       If some users do not exist in the system, they will be created.
   *       Legal entity cannot have viewers and prospects at the same time, so if this field is present then prospectEmails should be empty
   */
  viewerEmails: Array<Scalars['String']>;
};

export type CreateUserPreferenceQuestionInput = {
  /** Answers for this question */
  answers: Array<UserPreferenceAnswerInput>;
  /** Operator ID. This is optional for operators (their own operator ID will be used). This value is used by admin users */
  operatorId?: InputMaybe<Scalars['String']>;
  /** Question text */
  question: Scalars['String'];
};

/** The main list of curencies */
export enum Currency {
  Cad = 'CAD',
  /** This role has VISITOR priority to send us email after authorization */
  Chf = 'CHF',
  /** This role has OPERATOR priorities stored in DB level */
  Eur = 'EUR',
  /** This role has INVESTOR priorities stored in DB level */
  Gbp = 'GBP',
  /** This role has VISITOR priority to send us email after authorization */
  Ils = 'ILS',
  /** USD currency */
  Usd = 'USD',
}

export type CurrencyExchange = {
  __typename?: 'CurrencyExchange';
  /** Collection of currency pairs and their rates */
  currencyRates?: Maybe<CurrencyRatesObject>;
  /** Conversions dates in a string format (yyyy-mm-dd) */
  date?: Maybe<Scalars['String']>;
};

export type CurrencyRatesObject = {
  __typename?: 'CurrencyRatesObject';
  /** Currency rate from CAD to USD */
  CAD_USD?: Maybe<Scalars['Float']>;
  /** Currency rate from CHF to USD */
  CHF_USD?: Maybe<Scalars['Float']>;
  /** Currency rate from EUR to USD */
  EUR_USD?: Maybe<Scalars['Float']>;
  /** Currency rate from GBP to USD */
  GBP_USD?: Maybe<Scalars['Float']>;
  /** Currency rate from ILS to USD */
  ILS_USD?: Maybe<Scalars['Float']>;
};

export type CustomAnswer = {
  __typename?: 'CustomAnswer';
  /** User preference question */
  question: UserPreferenceQuestion;
  /** Question ID */
  questionID: Scalars['String'];
  /** Question answer keys */
  selectedAnswers: Array<Scalars['String']>;
};

export type CustomAnswerInput = {
  /** Question answer keys */
  answers: Array<Scalars['String']>;
  /** Question ID */
  questionID: Scalars['String'];
};

export type DateVersion = {
  __typename?: 'DateVersion';
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Record unique Id */
  id: Scalars['String'];
  /** Record start date */
  startDate: Scalars['DateTime'];
};

export type DraftFile = {
  __typename?: 'DraftFile';
  /** Files content type */
  content?: Maybe<Scalars['String']>;
  /** Date the file was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Name of the file */
  fileName?: Maybe<Scalars['String']>;
  /** If related to a fund, the fund id */
  fundId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** Locations details for the file with in the platform */
  locations?: Maybe<Array<FileLocation>>;
  /** If related to an offering, the offering id */
  offeringId?: Maybe<Scalars['String']>;
  /** Operator id */
  operatorId?: Maybe<Scalars['String']>;
  /** If related to a project within the fund portfolio, the project portfolio id */
  portfolioId?: Maybe<Scalars['String']>;
  /** If related to a project, the project id */
  projectId?: Maybe<Scalars['String']>;
  /** Whether the file is shared or not */
  shared?: Maybe<Scalars['Boolean']>;
  /** Size of the file */
  size?: Maybe<Scalars['Float']>;
  /** Status of the file */
  status?: Maybe<Scalars['String']>;
  /** Tags properties for the file */
  tags?: Maybe<Array<FileTags>>;
  /** thumbnail value of the file */
  thumbnail?: Maybe<Scalars['String']>;
  /** Date the file was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** url for download the file */
  url?: Maybe<Scalars['String']>;
  /** The version of the file record */
  version?: Maybe<Scalars['String']>;
};

/** The supported document file location within the platform */
export enum FileEntityTypeEnum {
  /** Fund entity */
  Fund = 'FUND',
  /** Reference to a fund portfolio */
  FundPortfolio = 'FUND_PORTFOLIO',
  /** Offer entity */
  Offer = 'OFFER',
  /** Operator entity */
  Operator = 'OPERATOR',
  /** Personal investor or viewer file */
  Personal = 'PERSONAL',
  /** Project entity */
  Project = 'PROJECT',
}

export type FileLocation = {
  __typename?: 'FileLocation';
  /** Id of the the entity that contains the file */
  entityId?: Maybe<Scalars['String']>;
  /** Type of the entity that contains the file */
  entityType?: Maybe<FileEntityTypeEnum>;
  /** location of the file within the page */
  locationInPage?: Maybe<FileLocationEnum>;
  /** Id of the the component that contains the file */
  locationInnerId?: Maybe<Scalars['String']>;
  /** Sort Index of the file within the page */
  sortIndex?: Maybe<Scalars['Float']>;
};

/** The supported document file location within the platform */
export enum FileLocationEnum {
  /** Documents section */
  Documents = 'DOCUMENTS',
  /** Document center */
  DocumentCenter = 'DOCUMENT_CENTER',
  /** Gallery */
  Gallery = 'GALLERY',
  /** Logo */
  Logo = 'LOGO',
  /** Main strip */
  Main = 'MAIN',
  /** Media center */
  MediaCenter = 'MEDIA_CENTER',
  /** Smart documents */
  SmartDocuments = 'SMART_DOCUMENTS',
  /** Smart documents untagged */
  SmartDocumentsUntagged = 'SMART_DOCUMENTS_UNTAGGED',
  /** Updates section */
  Updates = 'UPDATES',
}

export type FileLocationInput = {
  /** Id of the the entity that contains the file */
  entityId?: InputMaybe<Scalars['String']>;
  /** Type of the entity that contains the file */
  entityType?: InputMaybe<FileEntityTypeEnum>;
  /** location of the file within the page */
  locationInPage?: InputMaybe<FileLocationEnum>;
  /** Id of the the component that contains the file */
  locationInnerId?: InputMaybe<Scalars['String']>;
  /** Sort Index of the file within the page */
  sortIndex?: InputMaybe<Scalars['Float']>;
};

/** The supported document file tag */
export enum FileTagEnum {
  /** accreditation tag */
  Accreditation = 'ACCREDITATION',
  /** agreement tag */
  Agreement = 'AGREEMENT',
  /** area tag */
  Area = 'AREA',
  /** bank tag */
  Bank = 'BANK',
  /** custom tag */
  Custom = 'CUSTOM',
  /** documents tag */
  Documents = 'DOCUMENTS',
  /** gallery tag */
  Gallery = 'GALLERY',
  /** investor tag */
  Investor = 'INVESTOR',
  /** legal tag */
  Legal = 'LEGAL',
  /** logo tag */
  Logo = 'LOGO',
  /** main strip tag */
  Main = 'MAIN',
  /** media center tag */
  MediaCenter = 'MEDIA_CENTER',
  /** operator profile page */
  OperatorProfile = 'OPERATOR_PROFILE',
  /** suggested tag for the operator to choose */
  SuggestedTag = 'SUGGESTED_TAG',
  /** tax tag */
  Tax = 'TAX',
  /** untagged tag */
  Untagged = 'UNTAGGED',
  /** updates section tag */
  Update = 'UPDATE',
  /** viewer tag */
  Viewer = 'VIEWER',
}

export type FileTags = {
  __typename?: 'FileTags';
  /** Extra info for the tag, in case of a personal file - the name of the investor */
  extra?: Maybe<Scalars['String']>;
  /** Whether the file is hidden */
  hidden?: Maybe<Scalars['Boolean']>;
  /** For investors or viewers - holds the legal Entity Id */
  legalEntityId?: Maybe<Scalars['String']>;
  /** Type of the tag */
  type?: Maybe<FileTagEnum>;
  /** Value of the type file, in case of a personal file - the email of the investor */
  value?: Maybe<Scalars['String']>;
};

export type FileTagsInput = {
  /** Extra info for the tag, in case of a personal file - the name of the investor */
  extra?: InputMaybe<Scalars['String']>;
  /** Whether the file is hidden */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** For investors or viewers - holds the legal Entity Id */
  legalEntityId?: InputMaybe<Scalars['String']>;
  /** Type of the tag */
  type?: InputMaybe<FileTagEnum>;
  /** Value of the type file, in case of a personal file - the email of the investor */
  value?: InputMaybe<Scalars['String']>;
};

export type FontsInput = {
  /** font */
  boldFont: Scalars['String'];
  /** font */
  mainFont: Scalars['String'];
};

export type FontsObject = {
  __typename?: 'FontsObject';
  /** font */
  boldFont: Scalars['String'];
  /** font */
  mainFont: Scalars['String'];
};

export type FormulaClassInput = {
  /** from percentage */
  from: Scalars['Float'];
  /** GP percentage */
  gpPercentage: Scalars['Float'];
  /** Investor percentage */
  investorPercentage: Scalars['Float'];
  /** to percentage */
  to: Scalars['Float'];
};

export type FormulaClassObject = {
  __typename?: 'FormulaClassObject';
  /** from percentage */
  from: Scalars['Float'];
  /** GP percentage */
  gpPercentage: Scalars['Float'];
  /** Investor percentage */
  investorPercentage: Scalars['Float'];
  /** to percentage */
  to: Scalars['Float'];
};

export type Fund = {
  __typename?: 'Fund';
  /** Fund closing date */
  closingDate?: Maybe<Scalars['DateTime']>;
  /** Fund currency */
  currency?: Maybe<Currency>;
  /** Fund description */
  description?: Maybe<MultiLanguage>;
  /** Fund investments distribution */
  distributions?: Maybe<Array<ProjectPropertyDataObject>>;
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Current status */
  entityStatus: ProjectPublish;
  /** Record unique Id */
  id: Scalars['String'];
  /** Fund inception date */
  inceptionDate?: Maybe<Scalars['DateTime']>;
  /** Investment classes array related to this project */
  investmentClasses?: Maybe<Array<ProjectInvestmentClassesObject>>;
  /** Related investments */
  investmentDetails?: Maybe<Array<Investment>>;
  /** the fund kpis */
  kpis?: Maybe<Array<Scalars['String']>>;
  /** Fund view type layout */
  layout?: Maybe<Array<LayoutDataObject>>;
  /** Fund name */
  name?: Maybe<Scalars['String']>;
  /** Fund operator ref */
  operatorId: Scalars['String'];
  /** Fund origin ref */
  origin_ref?: Maybe<ProfimexRefObject>;
  /** Project portfolio (for manual entry) */
  portfolio?: Maybe<Array<FundPortfolioDataObject>>;
  /** Profimex fund id */
  profimexFundId?: Maybe<Scalars['String']>;
  /** Fund related projects */
  projectDetails?: Maybe<Array<FundProject>>;
  /** Fund properties ( distributions, assets, rents and et.c.) */
  properties?: Maybe<Array<ProjectPropertyObject>>;
  /** Record start date */
  startDate: Scalars['DateTime'];
  /** Fund status */
  status?: Maybe<ProjectStatus>;
  /** Project updates */
  updatesDetails?: Maybe<Array<Updates>>;
};

export type FundPortfolioDataInput = {
  /** Fund portfolio group */
  group?: InputMaybe<Scalars['String']>;
  /** Fund portfolio key */
  key?: InputMaybe<Scalars['String']>;
  /** Fund portfolio value */
  value?: InputMaybe<Scalars['String']>;
};

export type FundPortfolioDataObject = {
  __typename?: 'FundPortfolioDataObject';
  /** Fund portfolio group */
  group?: Maybe<Scalars['String']>;
  /** Fund portfolio key */
  key?: Maybe<Scalars['String']>;
  /** Fund portfolio value */
  value?: Maybe<Scalars['String']>;
};

export type FundProject = {
  __typename?: 'FundProject';
  /** Project category */
  category?: Maybe<ProjectCategory>;
  /** Project custom category */
  customCategory?: Maybe<Scalars['String']>;
  /** Project description */
  description?: Maybe<MultiLanguage>;
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Current status */
  entityStatus: ProjectPublish;
  /** Project ref */
  fundId: Scalars['String'];
  /** Record unique Id */
  id: Scalars['String'];
  /** Project view type layout */
  layout?: Maybe<Array<LayoutDataObject>>;
  /** Project address location with coordinates */
  location?: Maybe<ProjectLocationObject>;
  /** Project name */
  name?: Maybe<Scalars['String']>;
  /** operator id */
  operatorId?: Maybe<Scalars['String']>;
  /** the origin ref */
  origin_ref?: Maybe<Array<KeyValue>>;
  /** Project portfolio (for manual entry) */
  portfolio?: Maybe<Array<ProjectPortfolioDataObject>>;
  /** the profimex fund id */
  profimexFundId?: Maybe<Scalars['String']>;
  /** the profimex fund project id */
  profimexFundProjectId?: Maybe<Scalars['String']>;
  /** Operator linked project */
  projectDetails: Array<OperatorProject>;
  /** Operator linked project */
  projectId?: Maybe<Scalars['String']>;
  /** Record start date */
  startDate: Scalars['DateTime'];
};

export type GetInvestorDraftFilesInput = {
  /** legalEntity id */
  legalEntityIds: Array<Scalars['String']>;
};

export type GetInvestorPublicFileInput = {
  /** Requested project ids or fund ids or offering ids or portfolio ids */
  ids?: InputMaybe<Array<Scalars['String']>>;
  /** Whether to include personal files or not */
  includePersonalFiles?: InputMaybe<Scalars['Boolean']>;
};

export type GetInvestorPublicProjectFundFileInput = {
  /** Requested project ids or fund ids or offering ids or portfolio ids */
  ids?: InputMaybe<Array<Scalars['String']>>;
  /** File location to filter by */
  locationType?: InputMaybe<FileLocationEnum>;
};

export type GetOperatorPublicFileInput = {
  /** Requested project ids or fund ids or offering ids or portfolio ids */
  ids?: InputMaybe<Array<Scalars['String']>>;
  /** Whether to include personal files or not */
  includePersonalFiles?: InputMaybe<Scalars['Boolean']>;
  /** Investor id request as view as by the operator */
  investorId: Scalars['String'];
};

/** Status type for tax info, banking accounts, etc */
export enum InformationStatus {
  /** This information was approved by operator */
  Approved = 'approved',
  /**
   * Operator has marked this info as invalid, so the investor can change it accordingly.
   *       It is either missing some fields or incorrect.
   *       Additional info should be stored in the description
   */
  AttentionNeeded = 'attentionNeeded',
  /** Investor has requested some changes but operator hasn't approved them yet */
  PendingChanges = 'pendingChanges',
  /** This information was rejected by operator */
  Rejected = 'rejected',
}

export type Investment = {
  __typename?: 'Investment';
  /** Investment amount */
  amount?: Maybe<Scalars['Float']>;
  /** Investment commitment */
  commitment?: Maybe<Scalars['Float']>;
  /** Holds all the investment contribution information */
  contributions?: Maybe<Array<InvestmentContributionsObject>>;
  /** Investment statistics */
  customizedStatistics?: Maybe<Array<StatisticsKeyValue>>;
  /** Investment init date */
  date?: Maybe<Scalars['DateTime']>;
  /** Investment description */
  description?: Maybe<MultiLanguage>;
  /** Holds all the investment distributions */
  distributions?: Maybe<Array<InvestmentDistributionsObject>>;
  /** Investors emails */
  email: Array<Scalars['String']>;
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Current status */
  entityStatus: ProjectPublish;
  /** Investment exit date */
  exitDate?: Maybe<Scalars['DateTime']>;
  /** Fund details */
  fundDetails?: Maybe<Fund>;
  /** Gross Coc amount */
  grossCoc?: Maybe<Scalars['Float']>;
  /** Gross Irr amount */
  grossIrr?: Maybe<Scalars['Float']>;
  /** Gross Roi amount */
  grossRoi?: Maybe<Scalars['Float']>;
  /** Investment holdings */
  holdings?: Maybe<Array<InvestmentHoldingObject>>;
  /** Record unique Id */
  id: Scalars['String'];
  /** Invested by */
  investedBy: Scalars['String'];
  /** Defines investment as contribution */
  isContribution?: Maybe<Scalars['Boolean']>;
  /** User legal entity that made this investment */
  legalEntity: UserLegalEntity;
  /** user legal entity id that made this investment */
  legalEntityId: Scalars['String'];
  /** Investment holdings which was added manually for custom calculations */
  manualHoldings?: Maybe<Array<InvestmentHoldingObject>>;
  /** Net Coc amount */
  netCoc?: Maybe<Scalars['Float']>;
  /** Net Irr amount */
  netIrr?: Maybe<Scalars['Float']>;
  /** Net Roi amount */
  netRoi?: Maybe<Scalars['Float']>;
  /** Operator details */
  operatorDetails?: Maybe<Operator>;
  /** Investment unique Id */
  operatorId: Scalars['String'];
  /** Investment reference to profimex contribution transaction entity */
  origin_ref?: Maybe<ProfimexRefObject>;
  /** Investment percentage */
  percentage?: Maybe<Scalars['Float']>;
  /** Investment period time in months */
  period?: Maybe<Scalars['Float']>;
  /** Project details */
  projectDetails?: Maybe<OperatorProject>;
  /** Investment reference to project/fund */
  ref: Array<InvestmentRefObject>;
  /** Investment sequence id */
  sequenceId?: Maybe<Scalars['Float']>;
  /** Record start date */
  startDate: Scalars['DateTime'];
  /** Investment type */
  type: InvestmentType;
  /** Current document version */
  version?: Maybe<Scalars['Float']>;
};

/** Preference for investment amount */
export enum InvestmentAmountPreference {
  /** $500K and above */
  Over500 = 'over500',
  /** up to $50K */
  Under50 = 'under50',
  /** up to $100K */
  Under100 = 'under100',
  /** up to $250K */
  Under250 = 'under250',
  /** up to $500K */
  Under500 = 'under500',
}

/** Types of investment class */
export enum InvestmentClassEnum {
  /** debt type - used to calc fixed income */
  Debt = 'debt',
  /** equity type - used to calc percentage of ownership */
  Equity = 'equity',
}

export type InvestmentContributionsInput = {
  /** Capital call value amount */
  capitalCall?: InputMaybe<Scalars['Float']>;
  /** the endDate of the contribution */
  closingDate?: InputMaybe<Scalars['DateTime']>;
  /** Commitment value amount */
  commitment?: InputMaybe<Scalars['Float']>;
  /** the commitment release */
  commitmentRelease?: InputMaybe<Scalars['Float']>;
  /** Contribution value amount */
  contribution?: InputMaybe<Scalars['Float']>;
  /** Investment class currency */
  currency?: InputMaybe<Currency>;
  /** Rate for the currency conversion from the classes currency */
  currencyRate?: InputMaybe<Scalars['Float']>;
  /** Actual distribution date */
  date?: InputMaybe<Scalars['DateTime']>;
  /** Investment class formula */
  formula?: InputMaybe<Array<FormulaClassInput>>;
  /** Name of the related investment class */
  investmentClassName?: InputMaybe<Scalars['String']>;
  /** Notes taken which are related to this distribution */
  notes?: InputMaybe<Scalars['String']>;
  /** ProfimexRef for saving the transaction id of the contribution */
  origin_ref?: InputMaybe<ProfimexRefInput>;
  /** Whether this distribution was override manually */
  override?: InputMaybe<Scalars['Boolean']>;
  /** Percentage - fixed for debt , ownership for equity */
  percentage?: InputMaybe<Scalars['Float']>;
};

export type InvestmentContributionsObject = {
  __typename?: 'InvestmentContributionsObject';
  /** Capital call value amount */
  capitalCall?: Maybe<Scalars['Float']>;
  /** the endDate of the contribution */
  closingDate?: Maybe<Scalars['DateTime']>;
  /** Commitment value amount */
  commitment?: Maybe<Scalars['Float']>;
  /** the commitment release */
  commitmentRelease?: Maybe<Scalars['Float']>;
  /** Contribution value amount */
  contribution?: Maybe<Scalars['Float']>;
  /** Investment class currency */
  currency?: Maybe<Currency>;
  /** Rate for the currency conversion from the classes currency */
  currencyRate?: Maybe<Scalars['Float']>;
  /** Actual distribution date */
  date?: Maybe<Scalars['DateTime']>;
  /** Investment class formula */
  formula?: Maybe<Array<FormulaClassObject>>;
  /** Name of the related investment class */
  investmentClassName?: Maybe<Scalars['String']>;
  /** Notes taken which are related to this distribution */
  notes?: Maybe<Scalars['String']>;
  /** ProfimexRef for saving the transaction id of the contribution */
  origin_ref?: Maybe<ProfimexRefObject>;
  /** Whether this distribution was override manually */
  override?: Maybe<Scalars['Boolean']>;
  /** Percentage - fixed for debt , ownership for equity */
  percentage?: Maybe<Scalars['Float']>;
};

export type InvestmentDistributionsInput = {
  /** Distribution value amount */
  amount?: InputMaybe<Scalars['Float']>;
  /** Investment class currency */
  currency?: InputMaybe<Currency>;
  /** Rate for the currency conversion from the classes currency */
  currencyRate?: InputMaybe<Scalars['Float']>;
  /** Optional direct class name (used mainly for customized distribution) */
  customClassName?: InputMaybe<Scalars['String']>;
  /** Actual distribution date */
  date?: InputMaybe<Scalars['DateTime']>;
  /** Distribution period (ex. quarterly, monthly and etc) */
  distributionPeriod?: InputMaybe<Scalars['String']>;
  /** Total expenses for this distribution */
  expenses?: InputMaybe<Scalars['Float']>;
  /** type of the investment class (debt or equity) */
  investmentClassType?: InputMaybe<InvestmentClassEnum>;
  /** Override distribution value amount */
  manualAmount?: InputMaybe<Scalars['Float']>;
  /** Notes taken which are related to this distribution */
  notes?: InputMaybe<Scalars['String']>;
  /** ProfimexRef for saving the transaction id of the distribution */
  origin_ref?: InputMaybe<ProfimexRefInput>;
  /** Whether this distribution was override manually */
  override?: InputMaybe<Scalars['Boolean']>;
  /** Due date for debt distribution  */
  payDueDate?: InputMaybe<Scalars['DateTime']>;
  /** Types of the payment component */
  paymentComponent?: InputMaybe<PaymentComponentEnum>;
};

export type InvestmentDistributionsObject = {
  __typename?: 'InvestmentDistributionsObject';
  /** Distribution value amount */
  amount?: Maybe<Scalars['Float']>;
  /** Investment class currency */
  currency?: Maybe<Currency>;
  /** Rate for the currency conversion from the classes currency */
  currencyRate?: Maybe<Scalars['Float']>;
  /** Optional direct class name (used mainly for customized distribution) */
  customClassName?: Maybe<Scalars['String']>;
  /** Actual distribution date */
  date?: Maybe<Scalars['DateTime']>;
  /** Distribution period (ex. quarterly, monthly and etc) */
  distributionPeriod?: Maybe<Scalars['String']>;
  /** Total expenses for this distribution */
  expenses?: Maybe<Scalars['Float']>;
  /** type of the investment class (debt or equity) */
  investmentClassType?: Maybe<InvestmentClassEnum>;
  /** Override distribution value amount */
  manualAmount?: Maybe<Scalars['Float']>;
  /** Notes taken which are related to this distribution */
  notes?: Maybe<Scalars['String']>;
  /** ProfimexRef for saving the transaction id of the distribution */
  origin_ref?: Maybe<ProfimexRefObject>;
  /** Whether this distribution was override manually */
  override?: Maybe<Scalars['Boolean']>;
  /** Due date for debt distribution  */
  payDueDate?: Maybe<Scalars['DateTime']>;
  /** Types of the payment component */
  paymentComponent?: Maybe<PaymentComponentEnum>;
};

export type InvestmentHoldingInput = {
  /** Investment holding date */
  date?: InputMaybe<Scalars['DateTime']>;
  /** distribution reference to profimex distribution transaction entity */
  origin_ref?: InputMaybe<ProfimexRefInput>;
  /** Investment holding value */
  value?: InputMaybe<Scalars['String']>;
};

export type InvestmentHoldingObject = {
  __typename?: 'InvestmentHoldingObject';
  /** Investment holding date */
  date?: Maybe<Scalars['DateTime']>;
  /** distribution reference to profimex distribution transaction entity */
  origin_ref?: Maybe<ProfimexRefObject>;
  /** Investment holding value */
  value?: Maybe<Scalars['String']>;
};

/** The supported investment references (is it related to project or to fund) */
export enum InvestmentRef {
  /** This reference has fund relation */
  FundId = 'fundId',
  /** This reference has project relation */
  ProjectId = 'projectId',
}

export type InvestmentRefInput = {
  /** Investment reference key */
  key: InvestmentRef;
  /** Investment reference value */
  value: Scalars['String'];
};

export type InvestmentRefObject = {
  __typename?: 'InvestmentRefObject';
  /** Investment reference key */
  key: InvestmentRef;
  /** Investment reference value */
  value: Scalars['String'];
};

/** Investment structure preference that user can choose from */
export enum InvestmentStructurePreference {
  /** Fund */
  Fund = 'fund',
  SelfOwnership = 'selfOwnership',
  /** Stand alone projects */
  Standalone = 'standalone',
}

/** The supported investment type */
export enum InvestmentType {
  /** Calculated formula: (investment amount X investment interest rate) / investment period */
  Balloon = 'balloon',
  /** Calculated formula: relevant distribution value X investment percentage (This one is default) */
  Standard = 'standard',
}

/** Preference for investment type */
export enum InvestmentTypePreference {
  Commercial = 'commercial',
  Industrial = 'industrial',
  Residential = 'residential',
}

export type KeyValue = {
  __typename?: 'KeyValue';
  /** field */
  field: Scalars['String'];
  /** value */
  value: Scalars['String'];
};

export type KeyValueInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type KeyValueObject = {
  __typename?: 'KeyValueObject';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type KpiColorInput = {
  /** color */
  commitment: Scalars['String'];
  /** color */
  commitmentIcon: Scalars['String'];
  /** color */
  contribution: Scalars['String'];
  /** color */
  contributionIcon: Scalars['String'];
  /** color */
  custom1: Scalars['String'];
  /** color */
  custom1Icon: Scalars['String'];
  /** color */
  custom2: Scalars['String'];
  /** color */
  custom2Icon: Scalars['String'];
  /** color */
  custom3: Scalars['String'];
  /** color */
  custom3Icon: Scalars['String'];
  /** color */
  custom4: Scalars['String'];
  /** color */
  custom4Icon: Scalars['String'];
  /** color */
  custom5: Scalars['String'];
  /** color */
  custom5Icon: Scalars['String'];
  /** color */
  distribution: Scalars['String'];
  /** color */
  distributionIcon: Scalars['String'];
  /** color */
  openCommitments: Scalars['String'];
  /** color */
  openCommitmentsIcon: Scalars['String'];
  /** color */
  transfer: Scalars['String'];
  /** color */
  transferIcon: Scalars['String'];
};

export type KpiColorObject = {
  __typename?: 'KpiColorObject';
  /** color */
  commitment: Scalars['String'];
  /** color */
  commitmentIcon: Scalars['String'];
  /** color */
  contribution: Scalars['String'];
  /** color */
  contributionIcon: Scalars['String'];
  /** color */
  custom1: Scalars['String'];
  /** color */
  custom1Icon: Scalars['String'];
  /** color */
  custom2: Scalars['String'];
  /** color */
  custom2Icon: Scalars['String'];
  /** color */
  custom3: Scalars['String'];
  /** color */
  custom3Icon: Scalars['String'];
  /** color */
  custom4: Scalars['String'];
  /** color */
  custom4Icon: Scalars['String'];
  /** color */
  custom5: Scalars['String'];
  /** color */
  custom5Icon: Scalars['String'];
  /** color */
  distribution: Scalars['String'];
  /** color */
  distributionIcon: Scalars['String'];
  /** color */
  openCommitments: Scalars['String'];
  /** color */
  openCommitmentsIcon: Scalars['String'];
  /** color */
  transfer: Scalars['String'];
  /** color */
  transferIcon: Scalars['String'];
};

export type KpiNamesInput = {
  /** Names */
  accumulatedInterest?: Scalars['String'];
  /** Names */
  category?: Scalars['String'];
  /** Names */
  commitment?: Scalars['String'];
  /** Names */
  contribution?: Scalars['String'];
  /** Names */
  distribution?: Scalars['String'];
  /** Names */
  equityPercentage?: Scalars['String'];
  /** Names */
  investedCapital?: Scalars['String'];
  /** Names */
  openCommitments?: Scalars['String'];
  /** Names */
  transfer?: Scalars['String'];
};

export type KpiNamesObject = {
  __typename?: 'KpiNamesObject';
  /** Names */
  accumulatedInterest: Scalars['String'];
  /** Names */
  category: Scalars['String'];
  /** Names */
  commitment: Scalars['String'];
  /** Names */
  contribution: Scalars['String'];
  /** Names */
  distribution: Scalars['String'];
  /** Names */
  equityPercentage: Scalars['String'];
  /** Names */
  investedCapital: Scalars['String'];
  /** Names */
  openCommitments: Scalars['String'];
  /** Names */
  transfer: Scalars['String'];
};

/** The supported languages mainly for user default language option */
export enum Language {
  /** English */
  En = 'en',
  /** Hebrew */
  Heb = 'heb',
}

/** The layout for visibility control of available fields */
export enum Layout {
  /** This layout can control metadata of titles list */
  Titles = 'titles',
  /** This layout can control visibility of updateDetails list */
  UpdatesDetails = 'updatesDetails',
}

export type LayoutDataInput = {
  /** Param to change layout (updates, properties and et.c) */
  key?: InputMaybe<Layout>;
  /** Column names which can be visible */
  value?: InputMaybe<Array<Scalars['String']>>;
};

export type LayoutDataObject = {
  __typename?: 'LayoutDataObject';
  /** Param to change layout (updates, properties and et.c) */
  key?: Maybe<Layout>;
  /** Column names which can be visible */
  value?: Maybe<Array<Scalars['String']>>;
};

export type ManualInvestmentInput = {
  /** Investment operator unique Id */
  operatorId: Scalars['String'];
  /** Investment reference to project/fund */
  ref: Array<InvestmentRefInput>;
  /** Investment Version */
  version?: InputMaybe<Scalars['Float']>;
};

export type MergeUserLegalEntityInput = {
  /** If true, remaining entity unique ID will be used; otherwise removed entity unique ID will be used instead */
  keepRemainingEntityUniqueId: Scalars['Boolean'];
  /** User legal entity name after merge. Optional. If not provided, remaining legal entity name will be used */
  name?: InputMaybe<Scalars['String']>;
  /** User legal entity ID that should be preserved */
  remainingUserLegalEntityId: Scalars['String'];
  /** User legal entity ID that should be removed after merge */
  removedUserLegalEntityId: Scalars['String'];
};

export type MessageData = {
  /** project id */
  fundId?: InputMaybe<Scalars['String']>;
  /** offering id */
  offeringId?: InputMaybe<Scalars['String']>;
  /** project id */
  projectId?: InputMaybe<Scalars['String']>;
  /** the personal recipients subject */
  recipients?: InputMaybe<Array<RecipientInput>>;
  /** notification subject */
  subject: Scalars['String'];
  /** tepmlate type */
  templateType?: InputMaybe<Scalars['String']>;
  /** notification text */
  text?: InputMaybe<Scalars['String']>;
};

export type MultiLanObjectInput = {
  /** English text */
  en?: InputMaybe<Scalars['String']>;
  /** Hebrew text */
  heb?: InputMaybe<Scalars['String']>;
};

export type MultiLanguage = {
  __typename?: 'MultiLanguage';
  /** English text */
  en?: Maybe<Scalars['String']>;
  /** Hebrew text */
  heb?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** adds a admin to the operator */
  addAdmin: Scalars['String'];
  /** adds a legal entity to an sub admin */
  addLegalEntitiesToSubAdmin: Scalars['String'];
  /** Approve accreditation info provided by investor. All other accreditation info objects will be removed */
  approveAccreditationInfo: AccreditationInfo;
  /** Approve bank account provided by investor. If approvedBankAccountId is present in the current bank account, this will function as an update to approved document, otherwise it will add a new bank account entity */
  approveBankAccount: BankAccount;
  /** Approve tax info provided by investor. All other tax-info objects will be removed */
  approveTaxInfo: TaxInfo;
  /** Archive project entities by type. */
  archive: SimpleResponse;
  /** clear cache, available only for ADMIN role user */
  clearCache: Scalars['Boolean'];
  /**
   * Create new accreditation info for user legal entity.
   *         If info is already present, this will throw an error.
   *         Only available for admin or operators
   */
  createAccreditationInfo: AccreditationInfo;
  /**
   * Create new bank account for user legal entity.
   *         Only available for admin or operators
   */
  createBankAccount: BankAccount;
  /** create fund, available for ADMIN, OPERATOR role user */
  createFund: Fund;
  /** create fund project, available only for ADMIN, OPERATOR role user */
  createFundProject: FundProject;
  /** create investment, available for ADMIN, OPERATOR role user */
  createInvestments: Array<Investment>;
  /** create offer, available for ADMIN, OPERATOR role user */
  createOffer: Offer;
  /** create operator, available for ADMIN, OPERATOR role user */
  createOperator: Operator;
  /** create operator project, available only for ADMIN, OPERATOR role user */
  createOperatorProject: OperatorProject;
  /**
   * Create new tax info for user legal entity.
   *       Only available for admin or operators
   */
  createTaxInfo: TaxInfo;
  /** create updates, available only for ADMIN, OPERATOR role user */
  createUpdates: Updates;
  /** create user, available only for ADMIN role user */
  createUser: UserObject;
  /** Create user legal entity */
  createUserLegalEntity: UserLegalEntity;
  /** Create user preference question, that investor can answer */
  createUserPreferenceQuestion: UserPreferenceQuestion;
  deleteOrMarkDeleteFiles: Array<DraftFile>;
  /** Making publish to the choosen operator, available only for OPERATOR, ADMIN */
  doPublishCurrentUser: Array<UserPublishDiff>;
  /** remove cache record, available only for ADMIN, OPERATOR role user */
  logout: Scalars['Boolean'];
  markAsRead: Scalars['String'];
  /** Merge user legal entities. All investments, investors, viewers and prospects will be reassigned to remaining entity */
  mergeUserLegalEntities: UserLegalEntity;
  /** publishing all entities */
  publishAll: Scalars['Boolean'];
  publishFiles: Array<DraftFile>;
  /** Reject accreditation info (change status to 'rejected' and set endDate). */
  rejectAccreditationInfo: AccreditationInfo;
  /** Reject bank account (change status to 'rejected' and set endDate). This will not work for already approved bank account */
  rejectBankAccount: BankAccount;
  /** Reject tax info (change status to 'rejected' and set endDate). */
  rejectTaxInfo: TaxInfo;
  /** removes a admin from the operator */
  removeAdmin: Scalars['String'];
  removeFund: Fund;
  /** remove fund project, available only for ADMIN, OPERATOR role user */
  removeFundProject: FundProject;
  removeInvestment: Investment;
  removeInvestments: Array<Investment>;
  /** removes a legal entity from an sub admin */
  removeLegalEntitiesFromSubAdmin: Scalars['String'];
  /** Remove investor from legal entity (as investor or viewer) */
  removeLegalEntityUser: UserLegalEntity;
  removeOffer: Offer;
  removeOperator: Operator;
  removeOperatorProject: OperatorProject;
  removeUpdates: Updates;
  removeUser: UserObject;
  /** Remove user legal entity. Operator can only remove entities for assigned investors, admin for everyone */
  removeUserLegalEntity: UserLegalEntity;
  /** Remove user preference question */
  removeUserPreferenceQuestion: UserPreferenceQuestion;
  /** Send new accreditation info and request approval for it. Creates new accreditation info entity with 'pendingChanges' status */
  requestAccreditationInfoApproval: AccreditationInfo;
  /** Request some changes from investor. Marks accreditation info status to 'attentionNeeded' */
  requestAccreditationInfoChanges: AccreditationInfo;
  /** Request new changes to the bank account by investor. Creates new bank-account entity with 'pendingChanges' status. If bank-account id is missing, this means investor wants to add new bank-account */
  requestBankAccountApproval: BankAccount;
  /** Request some changes from investor. Marks bank account status to 'attentionNeeded' */
  requestBankAccountChanges: BankAccount;
  /** Request new changes to the tax info by investor. Creates new taxInfo entity with 'pendingChanges' status and two versions  -> unpublish and publish */
  requestTaxInfoApproval: TaxInfo;
  /** Request some changes from investor. Marks tax info status to 'attentionNeeded' */
  requestTaxInfoChanges: TaxInfo;
  /** resend a notification */
  resendNotification?: Maybe<Scalars['String']>;
  revertDeleteFiles: Array<DraftFile>;
  /** Allow to revert a document to a previous version */
  revertDocument: DateVersion;
  /** send an entities(fund or project) update notifications */
  sendEntityUpdate?: Maybe<Scalars['String']>;
  /** send an offering update notifications */
  sendOfferingUpdate?: Maybe<Scalars['String']>;
  /** send a operator update notifications */
  sendOperatorUpdateNotification?: Maybe<Scalars['String']>;
  /** send a personal document or operator update notifications */
  sendPersonalNotification?: Maybe<Scalars['String']>;
  /** send a welcome notifications */
  sendWelcomeNotification?: Maybe<Scalars['String']>;
  /** Set actions read by the operator */
  setActionsReadByOperator: Array<ActionsEntity>;
  signFiles: Array<DraftFile>;
  /** Update accreditation info by operator/admin */
  updateAccreditationInfo: AccreditationInfo;
  /** updates a admin from the operator */
  updateAdmin: Scalars['String'];
  /** Update bank account by operator/admin. Investor can update pending accounts */
  updateBankAccount: BankAccount;
  updateFiles: DraftFile;
  updateFund: Fund;
  /** update fund project, available only for ADMIN, OPERATOR role user */
  updateFundProject: FundProject;
  updateInvestments: Array<Investment>;
  updateInvestmentsDistributions: Array<Investment>;
  updateOffer: Offer;
  /** Update the related offering actions for this user */
  updateOfferingActions: Array<ActionsEntity>;
  updateOperator: Operator;
  updateOperatorProject: OperatorProject;
  /** Update user legal entity suggested preferences. Only operator or admin can update those */
  updateSuggestedUserPreferences: Array<UserPreference>;
  /** Update tax info by operator/admin */
  updateTaxInfo: TaxInfo;
  updateUpdates: Updates;
  /** update user, available only for ADMIN, OPERATOR, INVESTOR role user */
  updateUser: UserObject;
  /** Update user legal entity. If some investors with provided emails do not exist for current operator, they will be created */
  updateUserLegalEntity: UserLegalEntity;
  /** Update user preference question. Only admin can do this */
  updateUserPreferenceQuestion: UserPreferenceQuestion;
  /** Update user legal entity preferences. Only investor or admin can update those */
  updateUserPreferences: Array<UserPreference>;
};

export type MutationAddAdminArgs = {
  adminData: CreateOperatorAdminInput;
};

export type MutationAddLegalEntitiesToSubAdminArgs = {
  addingIds: AddLegalEntityToSubAdminInput;
};

export type MutationApproveAccreditationInfoArgs = {
  input: ApproveAccreditationInfoInput;
};

export type MutationApproveBankAccountArgs = {
  input: ApproveBankAccountInput;
};

export type MutationApproveTaxInfoArgs = {
  input: ApproveTaxInfoInput;
};

export type MutationArchiveArgs = {
  entityType: Populate;
  projectId: Scalars['String'];
};

export type MutationCreateAccreditationInfoArgs = {
  input: CreateAccreditationInfoInput;
};

export type MutationCreateBankAccountArgs = {
  input: CreateBankAccountInput;
};

export type MutationCreateFundArgs = {
  createFundInput: CreateFundInput;
};

export type MutationCreateFundProjectArgs = {
  createFundProjectInput: CreateFundProjectInput;
};

export type MutationCreateInvestmentsArgs = {
  createInvestmentInput: Array<CreateInvestmentInput>;
};

export type MutationCreateOfferArgs = {
  createOfferInput: CreateOfferInput;
};

export type MutationCreateOperatorArgs = {
  createOperatorInput: CreateOperatorInput;
};

export type MutationCreateOperatorProjectArgs = {
  createOperatorProjectInput: CreateOperatorProjectInput;
};

export type MutationCreateTaxInfoArgs = {
  input: CreateTaxInfoInput;
};

export type MutationCreateUpdatesArgs = {
  createUpdatesInput: CreateUpdatesInput;
};

export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};

export type MutationCreateUserLegalEntityArgs = {
  createUserLegalEntityInput: CreateUserLegalEntityInput;
};

export type MutationCreateUserPreferenceQuestionArgs = {
  input: CreateUserPreferenceQuestionInput;
};

export type MutationDeleteOrMarkDeleteFilesArgs = {
  ids: Array<Scalars['String']>;
};

export type MutationDoPublishCurrentUserArgs = {
  differences: Array<UserPublishInput>;
};

export type MutationMarkAsReadArgs = {
  notificationId: Scalars['String'];
};

export type MutationMergeUserLegalEntitiesArgs = {
  input: MergeUserLegalEntityInput;
};

export type MutationPublishFilesArgs = {
  ids: Array<Scalars['String']>;
};

export type MutationRejectAccreditationInfoArgs = {
  input: RejectAccreditationInfoInput;
};

export type MutationRejectBankAccountArgs = {
  input: RejectBankAccountInput;
};

export type MutationRejectTaxInfoArgs = {
  input: RejectTaxInfoInput;
};

export type MutationRemoveAdminArgs = {
  adminId: Scalars['String'];
};

export type MutationRemoveFundArgs = {
  id: Scalars['String'];
};

export type MutationRemoveFundProjectArgs = {
  id: Scalars['String'];
};

export type MutationRemoveInvestmentArgs = {
  id: Scalars['String'];
};

export type MutationRemoveInvestmentsArgs = {
  ids: Array<Scalars['String']>;
};

export type MutationRemoveLegalEntitiesFromSubAdminArgs = {
  removingIds: RemoveLegalEntityFromSubAdminInput;
};

export type MutationRemoveLegalEntityUserArgs = {
  input: RemoveLegalEntityUserInput;
};

export type MutationRemoveOfferArgs = {
  id: Scalars['String'];
};

export type MutationRemoveOperatorArgs = {
  id: Scalars['String'];
};

export type MutationRemoveOperatorProjectArgs = {
  id: Scalars['String'];
};

export type MutationRemoveUpdatesArgs = {
  id: Scalars['String'];
};

export type MutationRemoveUserArgs = {
  id: Scalars['String'];
};

export type MutationRemoveUserLegalEntityArgs = {
  userLegalEntityId: Scalars['String'];
};

export type MutationRemoveUserPreferenceQuestionArgs = {
  questionId: Scalars['String'];
};

export type MutationRequestAccreditationInfoApprovalArgs = {
  input: RequestAccreditationInfoApprovalInput;
};

export type MutationRequestAccreditationInfoChangesArgs = {
  input: RequestAccreditationInfoChangesInput;
};

export type MutationRequestBankAccountApprovalArgs = {
  input: RequestBankAccountApprovalInput;
};

export type MutationRequestBankAccountChangesArgs = {
  input: RequestBankAccountChangesInput;
};

export type MutationRequestTaxInfoApprovalArgs = {
  input: RequestTaxInfoApprovalInput;
};

export type MutationRequestTaxInfoChangesArgs = {
  input: RequestTaxInfoChangesInput;
};

export type MutationResendNotificationArgs = {
  id: Scalars['String'];
};

export type MutationRevertDeleteFilesArgs = {
  ids: Array<Scalars['String']>;
};

export type MutationRevertDocumentArgs = {
  id: Scalars['String'];
};

export type MutationSendEntityUpdateArgs = {
  messageData: MessageData;
  notifyAdmins: Scalars['Boolean'];
};

export type MutationSendOfferingUpdateArgs = {
  messageData: MessageData;
  notifyAdmins: Scalars['Boolean'];
};

export type MutationSendOperatorUpdateNotificationArgs = {
  messageData: MessageData;
  notifyAdmins: Scalars['Boolean'];
};

export type MutationSendPersonalNotificationArgs = {
  messageData: MessageData;
  notifyAdmins: Scalars['Boolean'];
};

export type MutationSendWelcomeNotificationArgs = {
  messageData: MessageData;
};

export type MutationSetActionsReadByOperatorArgs = {
  input: UpdateOfferingActionsOperatorStatusInput;
};

export type MutationSignFilesArgs = {
  ids: Array<Scalars['String']>;
};

export type MutationUpdateAccreditationInfoArgs = {
  input: UpdateAccreditationInfoInput;
};

export type MutationUpdateAdminArgs = {
  adminData: UpdateOperatorAdminInput;
};

export type MutationUpdateBankAccountArgs = {
  input: UpdateBankAccountInput;
};

export type MutationUpdateFilesArgs = {
  input: UpdateDraftFilesInput;
};

export type MutationUpdateFundArgs = {
  updateFundInput: UpdateFundInput;
};

export type MutationUpdateFundProjectArgs = {
  updateFundProjectInput: UpdateFundProjectInput;
};

export type MutationUpdateInvestmentsArgs = {
  updateInvestmentsInput: Array<UpdateInvestmentInput>;
};

export type MutationUpdateInvestmentsDistributionsArgs = {
  filter: ManualInvestmentInput;
};

export type MutationUpdateOfferArgs = {
  updateOfferInput: UpdateOfferInput;
};

export type MutationUpdateOfferingActionsArgs = {
  input: UpdateOfferingActionsInput;
};

export type MutationUpdateOperatorArgs = {
  updateOperatorInput: UpdateOperatorInput;
};

export type MutationUpdateOperatorProjectArgs = {
  updateOperatorProjectInput: UpdateOperatorProjectInput;
};

export type MutationUpdateSuggestedUserPreferencesArgs = {
  input: UpdateUserPreferencesInput;
};

export type MutationUpdateTaxInfoArgs = {
  input: UpdateTaxInfoInput;
};

export type MutationUpdateUpdatesArgs = {
  updateUpdatesInput: UpdateUpdatesInput;
};

export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};

export type MutationUpdateUserLegalEntityArgs = {
  input: UpdateUserLegalEntityInput;
};

export type MutationUpdateUserPreferenceQuestionArgs = {
  input: UpdateUserPreferenceQuestionInput;
};

export type MutationUpdateUserPreferencesArgs = {
  input: UpdateUserPreferencesInput;
};

/** The Notifications status */
export enum NotificationStatus {
  /** notification was bounced(address does not exist) */
  Bounced = 'bounced',
  /** notification was clicked */
  Click = 'click',
  /** notification was sent */
  Delivered = 'delivered',
  /** notification was dropped and not delivered */
  Dropped = 'dropped',
  /** notification was opened */
  Open = 'open',
  /** notification was sent */
  Sent = 'sent',
}

export type Notifications = {
  __typename?: 'Notifications';
  /** the date of the notification  */
  date?: Maybe<Scalars['DateTime']>;
  /** the fund id for the notification  */
  fundId?: Maybe<Scalars['String']>;
  /** the id for the notification  */
  id?: Maybe<Scalars['String']>;
  /** the notification id */
  messageId?: Maybe<Scalars['String']>;
  /** the operator id */
  operatorId?: Maybe<Scalars['String']>;
  /** the if the notification is personal  */
  personal?: Maybe<Scalars['Boolean']>;
  /** the project id for the notification  */
  projectId?: Maybe<Scalars['String']>;
  /** the reason why the notification was dropped */
  reason?: Maybe<Scalars['String']>;
  /** the id for the notification dropped */
  sendId?: Maybe<Scalars['String']>;
  /** the notification status */
  status?: Maybe<NotificationStatus>;
  /** the notification subject */
  subject?: Maybe<Scalars['String']>;
  /** the notification template id */
  templateId?: Maybe<Scalars['String']>;
  /** the notification template parameters */
  templateParams?: Maybe<TemplateData>;
  /** the email address */
  to?: Maybe<Array<Recipient>>;
};

export type Offer = {
  __typename?: 'Offer';
  /** audience for getting the offering */
  audience?: Maybe<Array<ProspectObject>>;
  /** Offer category */
  category?: Maybe<ProjectCategory>;
  /** Offer custom category */
  customCategory?: Maybe<Scalars['String']>;
  /** Offering description */
  description?: Maybe<MultiLanguage>;
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Current status */
  entityStatus: ProjectPublish;
  /** Record unique Id */
  id: Scalars['String'];
  /** freely defined key value kpi the offering */
  kpis?: Maybe<Array<OfferKpiObject>>;
  /** Offer address location with coordinates */
  location?: Maybe<ProjectLocationObject>;
  /** Offer name */
  name?: Maybe<Scalars['String']>;
  /** Offer start date */
  offerStartDate?: Maybe<Scalars['DateTime']>;
  /** Related operator */
  operatorDetails?: Maybe<Operator>;
  /** Offer operator ref */
  operatorId: Scalars['String'];
  /** Record start date */
  startDate: Scalars['DateTime'];
  /** Offer status */
  status?: Maybe<OfferingStatusEnum>;
  /** Offer strategy */
  strategy?: Maybe<Scalars['String']>;
};

export type OfferKpiInput = {
  /** Offer kpi key */
  key?: InputMaybe<Scalars['String']>;
  /** Offer kpi value */
  value?: InputMaybe<Scalars['String']>;
};

export type OfferKpiObject = {
  __typename?: 'OfferKpiObject';
  /** Offer kpi key */
  key?: Maybe<Scalars['String']>;
  /** Offer kpi value */
  value?: Maybe<Scalars['String']>;
};

/** Offering status */
export enum OfferingStatusEnum {
  /** Offering is active */
  Active = 'active',
  /** Offering is closed */
  Closed = 'closed',
  /** Offering is suspended */
  Suspended = 'suspended',
}

export type Operator = {
  __typename?: 'Operator';
  /** Operator contact list */
  contacts?: Maybe<Array<OperatorContactsObject>>;
  /** Operator description */
  description?: Maybe<MultiLanguage>;
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Current status */
  entityStatus: ProjectPublish;
  /** Operator related funds */
  fundDetails?: Maybe<Array<Fund>>;
  /** Record unique Id */
  id: Scalars['String'];
  /** if the operator is under maintenance */
  isUnderMaintenance?: Maybe<Scalars['Boolean']>;
  /** Array of supported languages */
  languagesSupport?: Maybe<Array<Scalars['String']>>;
  /** Operator view type layout */
  layout?: Maybe<Array<LayoutDataObject>>;
  /** Operator official name */
  name?: Maybe<Scalars['String']>;
  /** Operator related offerings */
  offerDetails?: Maybe<Array<Offer>>;
  /** Operator notifications */
  operatorNotifications?: Maybe<OperatorNotifications>;
  /** the categories to show in the overview */
  overviewKpisCategories: Array<Scalars['String']>;
  /** Operator package */
  package?: Maybe<Scalars['String']>;
  /** Operator related projects */
  projectDetails?: Maybe<Array<OperatorProject>>;
  /** the limit of restricted Admins */
  restrictedLimit?: Maybe<Scalars['Float']>;
  /** Record start date */
  startDate: Scalars['DateTime'];
  /** the limit of super Admins */
  superLimit?: Maybe<Scalars['Float']>;
  /** Operator updates */
  updatesDetails?: Maybe<Array<Updates>>;
  /** Operator related users */
  userDetails?: Maybe<Array<UserObject>>;
  /** Questions, that were created to set up investors preferences */
  userPreferenceQuestions: Array<UserPreferenceQuestion>;
  /** Operator user id */
  users: Array<Scalars['String']>;
  /** Operator website addres */
  websiteUrl?: Maybe<Scalars['String']>;
};

export type OperatorContactsInput = {
  /** Operator contact email */
  email?: InputMaybe<Scalars['String']>;
  /** Operator contact fax number */
  fax?: InputMaybe<Scalars['String']>;
  /** Operator main contact flag */
  main?: InputMaybe<Scalars['Boolean']>;
  /** Operator contact mobile */
  mobile?: InputMaybe<Scalars['String']>;
  /** Operator contact name */
  name?: InputMaybe<Scalars['String']>;
  /** Operator contact phone number */
  phone?: InputMaybe<Scalars['String']>;
};

export type OperatorContactsObject = {
  __typename?: 'OperatorContactsObject';
  /** Operator contact email */
  email?: Maybe<Scalars['String']>;
  /** Operator contact fax number */
  fax?: Maybe<Scalars['String']>;
  /** Operator main contact flag */
  main?: Maybe<Scalars['Boolean']>;
  /** Operator contact mobile */
  mobile?: Maybe<Scalars['String']>;
  /** Operator contact name */
  name?: Maybe<Scalars['String']>;
  /** Operator contact phone number */
  phone?: Maybe<Scalars['String']>;
};

export type OperatorNotifications = {
  __typename?: 'OperatorNotifications';
  /** Operator DemoUrl for notifications email message */
  notificationDemoUrl?: Maybe<Scalars['String']>;
  /** Operator Logo for notifications email message */
  notificationLogo?: Maybe<Scalars['String']>;
  /** Operator web url for notifications email message */
  notificationUrl?: Maybe<Array<Scalars['String']>>;
};

export type OperatorNotificationsInput = {
  /** Operator DemoUrl for notifications email message */
  notificationDemoUrl?: InputMaybe<Scalars['String']>;
  /** Operator Logo for notifications email message */
  notificationLogo?: InputMaybe<Scalars['String']>;
  /** Operator web url for notifications email message */
  notificationUrl?: InputMaybe<Array<Scalars['String']>>;
};

export type OperatorProject = {
  __typename?: 'OperatorProject';
  /** Project calculation type. */
  calculationType?: Maybe<CalculationType>;
  /** Project category */
  category?: Maybe<ProjectCategory>;
  /** Project end date */
  closingDate?: Maybe<Scalars['DateTime']>;
  /** Project currency */
  currency?: Maybe<Currency>;
  /** Project custom category */
  customCategory?: Maybe<Scalars['String']>;
  /** Project description */
  description?: Maybe<MultiLanguage>;
  /** Project investments distribution */
  distributions?: Maybe<Array<ProjectPropertyDataObject>>;
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Current status */
  entityStatus: ProjectPublish;
  /** Record unique Id */
  id: Scalars['String'];
  /** Project start date */
  inceptionDate?: Maybe<Scalars['DateTime']>;
  /** Investment classes array related to this project */
  investmentClasses?: Maybe<Array<ProjectInvestmentClassesObject>>;
  /** Related investments */
  investmentDetails?: Maybe<Array<Investment>>;
  /** the kpis */
  kpis?: Maybe<Array<Scalars['String']>>;
  /** Project view type layout */
  layout?: Maybe<Array<LayoutDataObject>>;
  /** Project address location with coordinates */
  location?: Maybe<ProjectLocationObject>;
  /** Project name */
  name?: Maybe<Scalars['String']>;
  /** Related operator */
  operatorDetails?: Maybe<Operator>;
  /** Project operator ref */
  operatorId: Scalars['String'];
  /** Project reference to profimex property entity */
  origin_ref?: Maybe<ProfimexRefObject>;
  /** Project portfolio (for manual entry) */
  portfolio?: Maybe<Array<ProjectPortfolioDataObject>>;
  /** Project cancellation date */
  projectCancellationDate?: Maybe<Scalars['DateTime']>;
  /** Project properties ( distributions, assets, rents and et.c.) */
  properties?: Maybe<Array<ProjectPropertyObject>>;
  /** Record start date */
  startDate: Scalars['DateTime'];
  /** Project status */
  status?: Maybe<ProjectStatus>;
  /** Project updates */
  updatesDetails?: Maybe<Array<Updates>>;
};

export type OriginRef = {
  __typename?: 'OriginRef';
  /** the client id */
  clientId?: Maybe<Scalars['String']>;
  /** the fund id */
  fundId?: Maybe<Scalars['String']>;
  /** Origin ref ID */
  id?: Maybe<Scalars['String']>;
  /** the project id */
  projectId?: Maybe<Scalars['String']>;
  /** Origin ref type */
  subType?: Maybe<Scalars['String']>;
  /** the transaction id */
  transactionId?: Maybe<Scalars['String']>;
};

/** Types of payment component */
export enum PaymentComponentEnum {
  /** Interest only is reduced from payment distribution - future payment will stay the same */
  Interest = 'interest',
  /** Principal only is reduced from payment distribution - future payment will be reduced */
  Principal = 'principal',
}

export type PendingRequest = {
  __typename?: 'PendingRequest';
  /** if there is a new accridiation */
  accreditation?: Maybe<Scalars['Boolean']>;
  /** if there is a new bank account */
  bank?: Maybe<Scalars['Boolean']>;
  /** the legal entity id */
  legalEntityId?: Maybe<Scalars['String']>;
  /** the legal entity name */
  name?: Maybe<Scalars['String']>;
  /** if there is a new tax info */
  tax?: Maybe<Scalars['Boolean']>;
};

export type PieColorInput = {
  /** color */
  colorA: Scalars['String'];
  /** color */
  colorB: Scalars['String'];
  /** color */
  colorC: Scalars['String'];
  /** color */
  colorD: Scalars['String'];
  /** color */
  colorE: Scalars['String'];
  /** color */
  colorF: Scalars['String'];
  /** color */
  colorG: Scalars['String'];
  /** color */
  colorH: Scalars['String'];
  /** color */
  colorI: Scalars['String'];
  /** color */
  colorJ: Scalars['String'];
};

export type PieColorObject = {
  __typename?: 'PieColorObject';
  /** color */
  colorA: Scalars['String'];
  /** color */
  colorB: Scalars['String'];
  /** color */
  colorC: Scalars['String'];
  /** color */
  colorD: Scalars['String'];
  /** color */
  colorE: Scalars['String'];
  /** color */
  colorF: Scalars['String'];
  /** color */
  colorG: Scalars['String'];
  /** color */
  colorH: Scalars['String'];
  /** color */
  colorI: Scalars['String'];
  /** color */
  colorJ: Scalars['String'];
};

/** The populate queries criteria */
export enum Populate {
  FundDetails = 'fundDetails',
  /** This is reference to the investment details */
  InvestmentDetails = 'investmentDetails',
  OfferDetails = 'offerDetails',
  /** This is reference to the operator details */
  OperatorDetails = 'operatorDetails',
  /** This is reference to the project details */
  ProjectDetails = 'projectDetails',
  /** This is reference to the updates details */
  UpdatesDetails = 'updatesDetails',
  /** This is reference to the user details */
  UserDetails = 'userDetails',
}

export type ProfimexOverview = {
  __typename?: 'ProfimexOverview';
  /** Active investment value for overview display */
  activeInvestments?: Maybe<Scalars['Float']>;
  /** Active investment value for overview display in USD */
  activeInvestmentsUSD?: Maybe<Scalars['Float']>;
  /** Currency code */
  currency?: Maybe<Scalars['String']>;
  /** Investor ID */
  investorId?: Maybe<Scalars['String']>;
  /** Open commitments value for overview display */
  openCommitments?: Maybe<Scalars['Float']>;
  /** Open commitments value for overview display in USD */
  openCommitmentsUSD?: Maybe<Scalars['Float']>;
  /** Operator ID */
  operatorId?: Maybe<Scalars['String']>;
  /** Profimex client ID */
  profimexClientId?: Maybe<Scalars['String']>;
  /** Total distribution value for overview display */
  totalDistribution?: Maybe<Scalars['Float']>;
  /** Total distribution value for overview display in USD */
  totalDistributionUSD?: Maybe<Scalars['Float']>;
  /** Last update date to display for overview values */
  updateDate?: Maybe<Scalars['DateTime']>;
};

export type ProfimexOverviewInput = {
  /** end date for the data base record */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Investor IDs */
  investorIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ProfimexRefInput = {
  /** This reference has transaction ID relation */
  ID?: InputMaybe<Scalars['String']>;
  /** This reference has client relation */
  clientId?: InputMaybe<Scalars['String']>;
  /** This reference has fund id relation */
  fundId?: InputMaybe<Scalars['String']>;
  /** This reference has project relation */
  projectId?: InputMaybe<Scalars['String']>;
  /** This reference has profimex propertyId relation */
  propertyId?: InputMaybe<Scalars['String']>;
  /** This reference has profimex property relation */
  property_num?: InputMaybe<Scalars['String']>;
  /** This reference has transaction relation */
  transactionId?: InputMaybe<Scalars['String']>;
};

export type ProfimexRefObject = {
  __typename?: 'ProfimexRefObject';
  /** This reference has transaction ID relation */
  ID?: Maybe<Scalars['String']>;
  /** This reference has client relation */
  clientId?: Maybe<Scalars['String']>;
  /** This reference has fund id relation */
  fundId?: Maybe<Scalars['String']>;
  /** This reference has project relation */
  projectId?: Maybe<Scalars['String']>;
  /** This reference has profimex propertyId relation */
  propertyId?: Maybe<Scalars['String']>;
  /** This reference has profimex property relation */
  property_num?: Maybe<Scalars['String']>;
  /** This reference has transaction relation */
  transactionId?: Maybe<Scalars['String']>;
};

export type ProfimexTransaction = {
  __typename?: 'ProfimexTransaction';
  /** Amount */
  amount: Scalars['Float'];
  /** Is transaction 'announcement' */
  announcement: Scalars['Boolean'];
  /** createdDate */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Currency code */
  currency: Scalars['String'];
  /** Exchange date */
  exchangeDate?: Maybe<Scalars['DateTime']>;
  /** Exchange rate */
  exchangeRate: Scalars['Float'];
  /** Transaction full name */
  fullNameEng: Scalars['String'];
  /** Transaction full name */
  fullNameHeb: Scalars['String'];
  /** Fund ID */
  fundId?: Maybe<Scalars['String']>;
  /** Transaction ID */
  id: Scalars['String'];
  /** Investor ID */
  investorId: Scalars['String'];
  /** Cash flag */
  isCash: Scalars['Boolean'];
  /** Local amount */
  localAmount: Scalars['Float'];
  /** sub transaction level xxxx(main)-yyy(sub order) */
  mainSubTx?: Maybe<Scalars['String']>;
  /** Transaction notes */
  notes?: Maybe<Scalars['String']>;
  /** Operator ID */
  operatorId: Scalars['String'];
  /** the origin ref */
  origin_ref?: Maybe<OriginRef>;
  /** Project ID */
  projectId?: Maybe<Scalars['String']>;
  /** Transaction short name */
  shortNameEng: Scalars['String'];
  /** Transaction short name */
  shortNameHeb: Scalars['String'];
  /** Transaction date */
  startDate: Scalars['DateTime'];
  /** sub transaction level xxxx(main)-yyy(sub order) */
  subTx?: Maybe<Scalars['String']>;
  /** Transaction notes HEB */
  transactionNotes: Scalars['String'];
  /** Transaction notes ENG */
  transactionNotesEng: Scalars['String'];
  /** Type of transaction */
  type: TransactionType;
};

/** The supported project categories */
export enum ProjectCategory {
  /** This category is for commercials property projects */
  Commercial = 'commercial',
  /** This category is for custom property projects, will be recorded under customCategory */
  Custom = 'custom',
  /** This category is for development property projects */
  Development = 'development',
  /** This category is for industrial property projects */
  Industrial = 'industrial',
  /** This category is for office property projects */
  OfficeBuildings = 'office_buildings',
  /** This category is for raw lands property projects */
  RawLand = 'raw_land',
  /** This category is for residentials property projects */
  Residential = 'residential',
}

export type ProjectInvestmentClassesInput = {
  /** Amount to allocate for the entire equity class (used to calc investors percentage from the class */
  allocationAmount?: InputMaybe<Scalars['Float']>;
  /** Investment class currency */
  currency?: InputMaybe<Currency>;
  /** Optional direct class name (used mainly for customized distribution) */
  customClassName?: InputMaybe<Scalars['String']>;
  /** Distribution period (ex. quarterly, monthly and etc) */
  distributionPeriod?: InputMaybe<Scalars['String']>;
  /** Investment class end date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Extension option end date */
  extensionOptionDate?: InputMaybe<Scalars['DateTime']>;
  /** Investment class formula */
  formula?: InputMaybe<Array<FormulaClassInput>>;
  /** Used to set a compounding calculation for the class */
  isCompounding?: InputMaybe<Scalars['Boolean']>;
  /** Used to lock the currency rate for all future distributions */
  lockCurrency?: InputMaybe<Scalars['Boolean']>;
  /** Unique name of the investment class */
  name: Scalars['String'];
  /** Percentage - fixed for debt , ownership for equity */
  percentage?: InputMaybe<Scalars['Float']>;
  /** type of the investment class (debt or equity) */
  type?: InputMaybe<InvestmentClassEnum>;
};

export type ProjectInvestmentClassesObject = {
  __typename?: 'ProjectInvestmentClassesObject';
  /** Amount to allocate for the entire equity class (used to calc investors percentage from the class */
  allocationAmount?: Maybe<Scalars['Float']>;
  /** Investment class currency */
  currency?: Maybe<Currency>;
  /** Optional direct class name (used mainly for customized distribution) */
  customClassName?: Maybe<Scalars['String']>;
  /** Distribution period (ex. quarterly, monthly and etc) */
  distributionPeriod?: Maybe<Scalars['String']>;
  /** Investment class end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Extension option end date */
  extensionOptionDate?: Maybe<Scalars['DateTime']>;
  /** Investment class formula */
  formula?: Maybe<Array<FormulaClassObject>>;
  /** Used to set a compounding calculation for the class */
  isCompounding?: Maybe<Scalars['Boolean']>;
  /** Used to lock the currency rate for all future distributions */
  lockCurrency?: Maybe<Scalars['Boolean']>;
  /** Unique name of the investment class */
  name: Scalars['String'];
  /** Percentage - fixed for debt , ownership for equity */
  percentage?: Maybe<Scalars['Float']>;
  /** type of the investment class (debt or equity) */
  type?: Maybe<InvestmentClassEnum>;
};

export type ProjectLocationInput = {
  /** Project phisical address */
  address?: InputMaybe<Scalars['String']>;
  /** Project latitude */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Project longitude */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type ProjectLocationObject = {
  __typename?: 'ProjectLocationObject';
  /** Project phisical address */
  address?: Maybe<Scalars['String']>;
  /** Project latitude */
  latitude?: Maybe<Scalars['Float']>;
  /** Project longitude */
  longitude?: Maybe<Scalars['Float']>;
};

export type ProjectPortfolioDataInput = {
  /** Project portfolio key */
  key?: InputMaybe<Scalars['String']>;
  /** Project portfolio value */
  value?: InputMaybe<Scalars['String']>;
};

export type ProjectPortfolioDataObject = {
  __typename?: 'ProjectPortfolioDataObject';
  /** Project portfolio key */
  key?: Maybe<Scalars['String']>;
  /** Project portfolio value */
  value?: Maybe<Scalars['String']>;
};

/** The supported project properties */
export enum ProjectProperty {
  /** This property is related to assets */
  Assets = 'assets',
  /** This property is related to coc */
  Coc = 'coc',
  /** This property is related to distributions */
  Distribution = 'distribution',
  /** This property is related to loans */
  Loans = 'loans',
  /** This property is related to ltc */
  Ltc = 'ltc',
  /** This property is related to noi */
  Noi = 'noi',
  /** This property is related to occupancy */
  Occupancy = 'occupancy',
  /** This property is related to rent */
  Rent = 'rent',
  /** This property is related to rent full occupancy */
  RentFullOccupancy = 'rent_full_occupancy',
  /** This property is related to rent growth */
  RentGrowth = 'rent_growth',
  /** This property is related to roe */
  Roe = 'roe',
  /** This property is related to roi */
  Roi = 'roi',
}

export type ProjectPropertyDataInput = {
  /** Distribution value amount */
  amount?: InputMaybe<Scalars['Float']>;
  /** Project property for custom note */
  annotation?: InputMaybe<Scalars['String']>;
  /** Investment class currency */
  currency?: InputMaybe<Currency>;
  /** Rate for the currency conversion from the classes currency */
  currencyRate?: InputMaybe<Scalars['Float']>;
  /** Optional direct class name (used mainly for customized distribution) */
  customClassName?: InputMaybe<Scalars['String']>;
  /** Actual distribution date */
  date?: InputMaybe<Scalars['DateTime']>;
  /** Distribution period (ex. quarterly, monthly and etc) */
  distributionPeriod?: InputMaybe<Scalars['String']>;
  /** Total expenses for this distribution */
  expenses?: InputMaybe<Scalars['Float']>;
  /** type of the investment class (debt or equity) */
  investmentClassType?: InputMaybe<InvestmentClassEnum>;
  /** Notes taken which are related to this distribution */
  notes?: InputMaybe<Scalars['String']>;
  /** Pay due date for debt - this is the date all all interest payment need to be fullfil */
  payDueDate?: InputMaybe<Scalars['DateTime']>;
  /** Types of the payment component */
  paymentComponent?: InputMaybe<PaymentComponentEnum>;
  /** Project property projected value */
  projected?: InputMaybe<Scalars['Float']>;
  /** Project property title */
  title?: InputMaybe<Scalars['String']>;
  /** Project property value (old version of amount) */
  value?: InputMaybe<Scalars['Float']>;
};

export type ProjectPropertyDataObject = {
  __typename?: 'ProjectPropertyDataObject';
  /** Distribution value amount */
  amount?: Maybe<Scalars['Float']>;
  /** Project property for custom note */
  annotation?: Maybe<Scalars['String']>;
  /** Investment class currency */
  currency?: Maybe<Currency>;
  /** Rate for the currency conversion from the classes currency */
  currencyRate?: Maybe<Scalars['Float']>;
  /** Optional direct class name (used mainly for customized distribution) */
  customClassName?: Maybe<Scalars['String']>;
  /** Actual distribution date */
  date?: Maybe<Scalars['DateTime']>;
  /** Distribution period (ex. quarterly, monthly and etc) */
  distributionPeriod?: Maybe<Scalars['String']>;
  /** Total expenses for this distribution */
  expenses?: Maybe<Scalars['Float']>;
  /** type of the investment class (debt or equity) */
  investmentClassType?: Maybe<InvestmentClassEnum>;
  /** Notes taken which are related to this distribution */
  notes?: Maybe<Scalars['String']>;
  /** Pay due date for debt - this is the date all all interest payment need to be fullfil */
  payDueDate?: Maybe<Scalars['DateTime']>;
  /** Types of the payment component */
  paymentComponent?: Maybe<PaymentComponentEnum>;
  /** Project property projected value */
  projected?: Maybe<Scalars['Float']>;
  /** Project property title */
  title?: Maybe<Scalars['String']>;
  /** Project property value (old version of amount) */
  value?: Maybe<Scalars['Float']>;
};

export type ProjectPropertyInput = {
  /** Project property name */
  key: ProjectProperty;
  /** Customized legend for the series 1 */
  series1Legend?: InputMaybe<MultiLanObjectInput>;
  /** Customized legend for the series 2 */
  series2Legend?: InputMaybe<MultiLanObjectInput>;
  /** Project property values */
  value: Array<ProjectPropertyDataInput>;
};

export type ProjectPropertyObject = {
  __typename?: 'ProjectPropertyObject';
  /** Project property name */
  key: ProjectProperty;
  /** Customized legend for the series 1 */
  series1Legend?: Maybe<MultiLanguage>;
  /** Customized legend for the series 2 */
  series2Legend?: Maybe<MultiLanguage>;
  /** Project property values */
  value: Array<ProjectPropertyDataObject>;
};

/** Is published or not */
export enum ProjectPublish {
  /** This for published projects */
  Publish = 'publish',
  /** This for unpublished projects */
  Unpublish = 'unpublish',
}

/** The project statuses */
export enum ProjectStatus {
  /** This status for cancelled projects */
  Cancelled = 'cancelled',
  /** This status for completed projects */
  Completed = 'completed',
  /** This status for pending projects */
  Pending = 'pending',
  /** This status for started projects */
  Started = 'started',
}

export type ProspectInput = {
  /** User email */
  email: Scalars['String'];
  /** User firstname */
  firstName?: InputMaybe<Scalars['String']>;
  /** User profile image URL */
  imgUrl?: InputMaybe<Scalars['String']>;
  /** User accredited status */
  isAccredited?: InputMaybe<Scalars['Boolean']>;
  /** User preferred language */
  language?: InputMaybe<Language>;
  /** User lastname */
  lastName?: InputMaybe<Scalars['String']>;
  /** User role */
  role: UserRoles;
  /** User settings */
  settings?: InputMaybe<UserSettingsInput>;
};

export type ProspectObject = {
  __typename?: 'ProspectObject';
  /** User email */
  email: Scalars['String'];
  /** User firstname */
  firstName?: Maybe<Scalars['String']>;
  /** User profile image URL */
  imgUrl?: Maybe<Scalars['String']>;
  /** User accredited status */
  isAccredited?: Maybe<Scalars['Boolean']>;
  /** User preferred language */
  language?: Maybe<Language>;
  /** User lastname */
  lastName?: Maybe<Scalars['String']>;
  /** User role */
  role: UserRoles;
  /** User settings */
  settings?: Maybe<UserSettingsObject>;
};

export type PublicFile = {
  __typename?: 'PublicFile';
  /** Files content type */
  content?: Maybe<Scalars['String']>;
  /** Date the file was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Name of the file */
  fileName?: Maybe<Scalars['String']>;
  /** If related to a fund, the fund id */
  fundId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** Locations details for the file with in the platform */
  locations?: Maybe<Array<FileLocation>>;
  /** If related to an offering, the offering id */
  offeringId?: Maybe<Scalars['String']>;
  /** Operator id */
  operatorId?: Maybe<Scalars['String']>;
  /** If related to a project within the fund portfolio, the project portfolio id */
  portfolioId?: Maybe<Scalars['String']>;
  /** If related to a project, the project id */
  projectId?: Maybe<Scalars['String']>;
  /** Whether the file is shared or not */
  shared?: Maybe<Scalars['Boolean']>;
  /** Size of the file */
  size?: Maybe<Scalars['Float']>;
  /** Status of the file */
  status?: Maybe<Scalars['String']>;
  /** Tags properties for the file */
  tags?: Maybe<Array<FileTags>>;
  /** thumbnail value of the file */
  thumbnail?: Maybe<Scalars['String']>;
  /** Date the file was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** url for download the file */
  url?: Maybe<Scalars['String']>;
  /** The version of the file record */
  version?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  /** fetch all currency rates by date, available only for ADMIN role user */
  allCurrencyRates: Array<CurrencyExchange>;
  /** fetch all today currency rates, available only for ADMIN role user */
  currencyRates: CurrencyRatesObject;
  /** fetch all fund projects, available only for ADMIN role user */
  findAllFundProjects: Array<FundProject>;
  /** fetch all funds, available only for ADMIN role user */
  findAllFunds: Array<Fund>;
  /** fetch all investments, available only for ADMIN role user */
  findAllInvestments: Array<Investment>;
  /** fetch all offers, available only for ADMIN role user */
  findAllOffers: Array<Offer>;
  /** fetch all operator projects, available only for ADMIN role user */
  findAllOperatorProjects: Array<OperatorProject>;
  /** fetch all operators, available only for ADMIN role user */
  findAllOperators: Array<Operator>;
  /** fetch all offers, available only for ADMIN role user */
  findAllPublicOffers: Array<Offer>;
  /** fetch all offers, available only for ADMIN role user */
  findAllPublicOffersByOperator: Array<Offer>;
  /** fetch all updates, available only for ADMIN role user */
  findAllUpdates: Array<Updates>;
  /** fetch all users, available only for ADMIN role user */
  findAllUsers: Array<UserObject>;
  /** fetch investments by operatorId and ref, available only for ADMIN OPERATOR role user */
  findCurrentInvestments?: Maybe<Array<Investment>>;
  /** fetch operators by current user token, available for ADMIN, OPERATOR role user */
  findCurrentOperators?: Maybe<Array<Operator>>;
  /** fetch user by current user token, available only for ADMIN, OPERATOR, INVESTOR role user */
  findCurrentUser?: Maybe<UserObject>;
  /** Fetch user by his id. Operator can only fetch users that assigned to operator`s legal entities */
  findInvestorUser: UserObject;
  /** fetch marketplace user by current user token, available only for ADMIN, OPERATOR, INVESTOR role user */
  findMarketplaceUser?: Maybe<UserObject>;
  /** fetch all operator projects, available only for ADMIN role user */
  findOperatorFundById: Fund;
  /** fetch operator investor by email */
  findOperatorInvestorByEmail?: Maybe<UserObject>;
  /** fetch operator investors list */
  findOperatorInvestorsList: Array<UserObject>;
  /** fetch all operator projects, available only for Operator and ADMIN role user */
  findOperatorProjectById: OperatorProject;
  /** fetch users by emails. Operator can view investors only, and admin can view investors+operators */
  findUsers: Array<UserObject>;
  /** Fetch operator investors activity (login, sign up, etc). Source is oauth api and mongo db */
  findUsersActivity: UserActivityPage;
  /** fetch the operator type (super admin or limited admin) */
  getAdminType?: Maybe<Scalars['String']>;
  /** getting all of the admins, name and email, and id */
  getAllAdmins: Array<UserObject>;
  getAllInvestorDraftFiles: Array<DraftFile>;
  /** get all the notifications for a operator */
  getAllNotificationsByOperator?: Maybe<Array<Notifications>>;
  /** Get all operator actions */
  getAllOperatorActions: Array<ActionsEntity>;
  getAllOperatorFiles: Array<DraftFile>;
  getAllUnpublishedDraftFiles: Array<DraftFile>;
  getAllUntaggedDraftFiles: Array<DraftFile>;
  /** Get all bank accounts and related data for user legal entities. Only available for admin or operators */
  getDataFileForBank: Array<BankFileOutput>;
  getDraftFilesById: Array<DraftFile>;
  getDraftFilesByIds: Array<DraftFile>;
  getInvestorDraftFiles: Array<DraftFile>;
  getInvestorDraftProjectsFundsFiles: Array<DraftFile>;
  getInvestorProjectsFundsFiles: Array<PublicFile>;
  getInvestorPublicFiles: Array<PublicFile>;
  getInvestorPublicFilesByOperator: Array<PublicFile>;
  getInvestorTransactions: Array<ProfimexTransaction>;
  getLastUpdated: Scalars['DateTime'];
  /** gets the restricted admin for an investor by the investor id */
  getManagerDetails: Array<UserObject>;
  getPendingRequest: Array<PendingRequest>;
  getProfimexInvestorOverviewData: Array<ProfimexOverview>;
  getSmartDocumentsDraftFiles: Array<DraftFile>;
  getTemplateById: Scalars['String'];
  getTheme: Theme;
  getUnreadNotificationsNumber: Scalars['Float'];
  /** get user statistics, available only for ADMIN role user */
  getUserActiveRecords: UserActiveUsers;
  getUserNotifications: Array<Notifications>;
  /** fetch the backend version */
  getVersion?: Maybe<Scalars['String']>;
  /** Pls check https://www.npmjs.com/package/deep-diff for more info about diff object, available only for OPERATOR, ADMIN */
  prePublishCurrentUser?: Maybe<Array<UserPublishDiff>>;
  /** Pls check https://www.npmjs.com/package/deep-diff for more info about diff object, available only for ADMIN */
  prePublishUser?: Maybe<Array<UserPublishDiff>>;
  /** Request all public offering actions for this user */
  requestAllPublicOfferingActions: Array<ActionsEntity>;
  /** User legal entities lookup query */
  userLegalEntities: UserLegalEntityPage;
};

export type QueryCurrencyRatesArgs = {
  date?: InputMaybe<Scalars['String']>;
};

export type QueryFindAllFundProjectsArgs = {
  filter?: InputMaybe<SearchFundProjectInput>;
};

export type QueryFindAllInvestmentsArgs = {
  filter?: InputMaybe<SearchInvestmentInput>;
};

export type QueryFindAllOperatorProjectsArgs = {
  filter?: InputMaybe<SearchOperatorProjectInput>;
};

export type QueryFindAllOperatorsArgs = {
  filter?: InputMaybe<SearchOperatorInput>;
};

export type QueryFindAllUsersArgs = {
  filter?: InputMaybe<SearchUserInput>;
};

export type QueryFindCurrentInvestmentsArgs = {
  filter: ManualInvestmentInput;
};

export type QueryFindInvestorUserArgs = {
  id: Scalars['String'];
};

export type QueryFindOperatorFundByIdArgs = {
  id: Scalars['String'];
};

export type QueryFindOperatorInvestorByEmailArgs = {
  emailSearch: Scalars['String'];
  operatorId: Scalars['String'];
};

export type QueryFindOperatorInvestorsListArgs = {
  operatorId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};

export type QueryFindOperatorProjectByIdArgs = {
  id: Scalars['String'];
};

export type QueryFindUsersArgs = {
  emails: Array<Scalars['String']>;
};

export type QueryFindUsersActivityArgs = {
  input: UserActivityInput;
};

export type QueryGetAllUnpublishedDraftFilesArgs = {
  includePendingDelete: Scalars['Boolean'];
};

export type QueryGetDataFileForBankArgs = {
  bankFileInput: CreateBankFileInput;
};

export type QueryGetDraftFilesByIdArgs = {
  id: Scalars['String'];
};

export type QueryGetDraftFilesByIdsArgs = {
  ids: Array<Scalars['String']>;
};

export type QueryGetInvestorDraftFilesArgs = {
  input: GetInvestorDraftFilesInput;
};

export type QueryGetInvestorDraftProjectsFundsFilesArgs = {
  input: GetInvestorPublicProjectFundFileInput;
};

export type QueryGetInvestorProjectsFundsFilesArgs = {
  input: GetInvestorPublicProjectFundFileInput;
};

export type QueryGetInvestorPublicFilesArgs = {
  input: GetInvestorPublicFileInput;
};

export type QueryGetInvestorPublicFilesByOperatorArgs = {
  input: GetOperatorPublicFileInput;
};

export type QueryGetInvestorTransactionsArgs = {
  investorId?: InputMaybe<Scalars['String']>;
};

export type QueryGetManagerDetailsArgs = {
  filterId: Scalars['String'];
  investorId: Scalars['String'];
};

export type QueryGetProfimexInvestorOverviewDataArgs = {
  filter?: InputMaybe<ProfimexOverviewInput>;
};

export type QueryGetTemplateByIdArgs = {
  id: Scalars['String'];
};

export type QueryGetThemeArgs = {
  id: Scalars['String'];
};

export type QueryGetUnreadNotificationsNumberArgs = {
  relatedId: Scalars['String'];
};

export type QueryGetUserNotificationsArgs = {
  latest: Scalars['String'];
  relatedId: Scalars['String'];
};

export type QueryPrePublishUserArgs = {
  userId: Scalars['String'];
};

export type QueryUserLegalEntitiesArgs = {
  filter: UserLegalEntityFilter;
};

export type Recipient = {
  __typename?: 'Recipient';
  /** the email of the recipient */
  email?: Maybe<Scalars['String']>;
  /** the id of the recipient */
  id?: Maybe<Scalars['String']>;
  /** the name of the recipient */
  name?: Maybe<Scalars['String']>;
};

export type RecipientInput = {
  /** the email of the recipient */
  email?: InputMaybe<Scalars['String']>;
  /** the id of the recipient */
  id?: InputMaybe<Scalars['String']>;
  /** the name of the recipient */
  name?: InputMaybe<Scalars['String']>;
  /** the id type */
  type?: InputMaybe<Scalars['String']>;
};

export type RejectAccreditationInfoInput = {
  /** Accreditation info id */
  accreditationInfoId: Scalars['String'];
  /** Notes, why this info was rejected */
  notes: Scalars['String'];
};

export type RejectBankAccountInput = {
  /** Bank account id */
  bankAccountId: Scalars['String'];
  /** Notes, why this bank account was rejected */
  notes: Scalars['String'];
};

export type RejectTaxInfoInput = {
  /** Operator notes, why this info was rejected */
  notes: Scalars['String'];
  /** Tax info id */
  taxInfoId: Scalars['String'];
};

export type RemoveLegalEntityFromSubAdminInput = {
  /** User legal entity ids */
  legalEntityIds: Array<Scalars['String']>;
  /** The sub admin id */
  subAdminId: Scalars['String'];
};

export type RemoveLegalEntityUserInput = {
  /** User id, that should be removed from provided user legal entity. This will remove user from any of the next fields: investors, viewers, prospects. */
  userId: Scalars['String'];
  /** User legal entity ID */
  userLegalEntityId: Scalars['String'];
};

export type RequestAccreditationInfoApprovalInput = {
  /** Accreditation type */
  accreditationType: AccreditationType;
  /** Country of residency */
  country: Scalars['String'];
  /** This info won`t be valid after this date. Not applicable for non-accredited investors */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** User legal entity id */
  userLegalEntityId: Scalars['String'];
};

export type RequestAccreditationInfoChangesInput = {
  /** Accreditation info id */
  accreditationInfoId: Scalars['String'];
  /** Additional message for an investor */
  notes: Scalars['String'];
};

export type RequestBankAccountApprovalInput = {
  /** Bank identification number */
  IBAN?: InputMaybe<Scalars['String']>;
  /** Account name */
  accountName?: InputMaybe<Scalars['String']>;
  /** Account number */
  accountNumber?: InputMaybe<Scalars['String']>;
  /** Bank account id. If this id is not provided, it means investor wants to create a new bank account (otherwise to update an existing account) */
  approvedBankAccountId?: InputMaybe<Scalars['String']>;
  /** Bank name */
  bankName?: InputMaybe<Scalars['String']>;
  /** Bank identification number */
  benificiaryAddress?: InputMaybe<Scalars['String']>;
  /** Full address for bank branch */
  branchAddress?: InputMaybe<Scalars['String']>;
  /** Bank branch number */
  branchNumber?: InputMaybe<Scalars['String']>;
  /** the currencies the bank account will be used for. */
  currencies?: InputMaybe<Array<Scalars['String']>>;
  /** Is active */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Routing Number /ABA */
  routingNumber?: InputMaybe<Scalars['String']>;
  /** the swift */
  swift?: InputMaybe<Scalars['String']>;
  /** User legal entity id */
  userLegalEntityId: Scalars['String'];
};

export type RequestBankAccountChangesInput = {
  /** Bank account id */
  bankAccountId: Scalars['String'];
  /** Additional notes, that only operator can see */
  notes: Scalars['String'];
};

export type RequestTaxInfoApprovalInput = {
  /** Social security number */
  SSN?: InputMaybe<Scalars['String']>;
  /** Tax identification number */
  TIN?: InputMaybe<Scalars['String']>;
  /** Full address for this legal entity */
  address: Scalars['String'];
  /** User legal entity id */
  userLegalEntityId: Scalars['String'];
};

export type RequestTaxInfoChangesInput = {
  /** Additional notes, that only operator can see */
  notes: Scalars['String'];
  /** Tax info id */
  taxInfoId: Scalars['String'];
};

/** Preference for investment type */
export enum RiskRewardPreference {
  /** High risk, high returns */
  High = 'high',
  /** Moderate risk, moderate returns */
  Moderate = 'moderate',
  /** Low risk, low returns */
  Safe = 'safe',
}

export type SearchFundProjectInput = {
  /** Project category */
  category?: InputMaybe<ProjectCategory>;
  /** Project currency */
  currency?: InputMaybe<Scalars['String']>;
  /** Project operator ref */
  fundId?: InputMaybe<Scalars['String']>;
  /** Project uniq id */
  id?: InputMaybe<Scalars['String']>;
  /** Project address location */
  location?: InputMaybe<ProjectLocationInput>;
  /** Project name */
  name?: InputMaybe<Scalars['String']>;
  /** Project status */
  status?: InputMaybe<ProjectStatus>;
};

export type SearchInvestmentInput = {
  /** Investment amount */
  amount?: InputMaybe<Scalars['Float']>;
  /** Investment commitment */
  commitment?: InputMaybe<Scalars['Float']>;
  /** Investment description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Investors emails */
  email?: InputMaybe<Array<Scalars['String']>>;
  /** Investment unique Id */
  id?: InputMaybe<Scalars['String']>;
  /** Invested by */
  investedBy?: InputMaybe<Scalars['String']>;
  /** Investment operator unique Id */
  operatorId?: InputMaybe<Scalars['String']>;
  /** Investment percentage */
  percentage?: InputMaybe<Scalars['Float']>;
  /** Investment reference to project/fund */
  ref?: InputMaybe<Array<InvestmentRefInput>>;
};

export type SearchOperatorInput = {
  /** Operator contact list */
  contacts?: InputMaybe<Array<OperatorContactsInput>>;
  /** Operator description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Operator entity status (publish/unpublish) */
  entityStatus?: InputMaybe<ProjectPublish>;
  /** Operator unique Id */
  id?: InputMaybe<Scalars['String']>;
  /** Operator profile image URL */
  imgUrl?: InputMaybe<Scalars['String']>;
  /** Operator view type layout */
  layout?: InputMaybe<Scalars['String']>;
  /** Operator official name */
  name?: InputMaybe<Scalars['String']>;
  /** Operator users */
  users?: InputMaybe<Array<Scalars['String']>>;
  /** Operator website addres */
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type SearchOperatorProjectInput = {
  /** Project category */
  category?: InputMaybe<ProjectCategory>;
  /** Project currency */
  currency?: InputMaybe<Currency>;
  /** Project description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Project uniq id */
  id?: InputMaybe<Scalars['String']>;
  /** Project address location */
  location?: InputMaybe<ProjectLocationInput>;
  /** Project name */
  name?: InputMaybe<Scalars['String']>;
  /** Project operator ref */
  operatorId?: InputMaybe<Scalars['String']>;
  /** Project properties ( distributions, assets, rents and et.c.) */
  properties?: InputMaybe<Array<ProjectPropertyInput>>;
  /** Project status */
  status?: InputMaybe<ProjectStatus>;
};

export type SearchUserInput = {
  /** User email */
  email?: InputMaybe<Scalars['String']>;
  /** User firstname */
  firstName?: InputMaybe<Scalars['String']>;
  /** User unique Id */
  id?: InputMaybe<Scalars['String']>;
  /** User profile image */
  imgUrl?: InputMaybe<Scalars['String']>;
  /** User preffered language */
  language?: InputMaybe<Language>;
  /** User lastname */
  lastName?: InputMaybe<Scalars['String']>;
  /** User role */
  role?: InputMaybe<UserRoles>;
  /** User settings */
  settings?: InputMaybe<UserSettingsInput>;
};

export type SimpleResponse = {
  __typename?: 'SimpleResponse';
  succeed: Scalars['Boolean'];
};

export type StatisticsKeyValue = {
  __typename?: 'StatisticsKeyValue';
  /** the Key */
  key?: Maybe<Scalars['String']>;
  /** the value */
  value?: Maybe<Scalars['String']>;
};

export type StatisticsKeyValueInput = {
  /** the Key */
  key?: InputMaybe<Scalars['String']>;
  /** the value */
  value?: InputMaybe<Scalars['String']>;
};

/** Strategy investment types preferences */
export enum StrategyTypePreference {
  Cashflow = 'cashflow',
  Development = 'development',
  Rehabilitation = 'rehabilitation',
  Zoning = 'zoning',
}

export type TaxInfo = {
  __typename?: 'TaxInfo';
  /** Social security number (either TIN or SSN is required) */
  SSN?: Maybe<Scalars['String']>;
  /** Tax identification number (either TIN or SSN is required) */
  TIN?: Maybe<Scalars['String']>;
  /** Full address for this legal entity */
  address?: Maybe<Scalars['String']>;
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Current status */
  entityStatus: ProjectPublish;
  /** Record unique Id */
  id: Scalars['String'];
  /** Text, that only operator can see and edit. */
  notes?: Maybe<Scalars['String']>;
  /** Record start date */
  startDate: Scalars['DateTime'];
  /** Status for this info */
  status: InformationStatus;
  /** User legal entity that this tax info belongs to */
  userLegalEntity: UserLegalEntity;
  /** User legal entity id */
  userLegalEntityId: Scalars['String'];
};

export type TemplateData = {
  __typename?: 'TemplateData';
  /** the the email of the investor */
  investor_email?: Maybe<Scalars['String']>;
  /** the name of the investor */
  investor_name?: Maybe<Scalars['String']>;
  /** the the text of the notification */
  message?: Maybe<Scalars['String']>;
  /** the the text of the notification */
  message_text?: Maybe<Scalars['String']>;
  /** the id of the offering */
  offering_id?: Maybe<Scalars['String']>;
  /** the name of the offering */
  offering_name?: Maybe<Scalars['String']>;
  /** the the link to the operator demo url */
  operator_demo_url?: Maybe<Scalars['String']>;
  /** the the link to the operator Logo */
  operator_logo?: Maybe<Scalars['String']>;
  /** the name of the operator */
  operator_name?: Maybe<Scalars['String']>;
  /** the link to the operator homepage */
  operator_url?: Maybe<Scalars['String']>;
  /** the name project or fund */
  project_fund_name?: Maybe<Scalars['String']>;
  /** the name project or fund */
  project_name?: Maybe<Scalars['String']>;
  /** the subject of the notification */
  subject?: Maybe<Scalars['String']>;
};

export type Theme = {
  __typename?: 'Theme';
  /** the graph bar colors */
  barColors?: Maybe<BarColorObject>;
  /** the category colors  */
  categoryColors?: Maybe<CategoryColorObject>;
  /** the overview kpi  */
  colors?: Maybe<ColorObject>;
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Current status */
  entityStatus: ProjectPublish;
  /** the fonts   */
  fonts?: Maybe<FontsObject>;
  /** Record unique Id */
  id: Scalars['String'];
  /** the kpi colors */
  kpiColors?: Maybe<KpiColorObject>;
  /** the kpi names  */
  kpiNames?: Maybe<KpiNamesObject>;
  /** the operator id  */
  operatorId?: Maybe<Scalars['String']>;
  /** the pie colors  */
  pieColors?: Maybe<PieColorObject>;
  /** Record start date */
  startDate: Scalars['DateTime'];
};

/** Type of transaction. */
export enum TransactionType {
  /** Contribution transaction. */
  Contribution = 'CONTRIBUTION',
  /** Distribution transaction. */
  Distribution = 'DISTRIBUTION',
  /** Transfer transaction ownership. */
  Transfer = 'TRANSFER',
}

export type UpdateAccreditationInfoInput = {
  /** Accreditation info ID */
  accreditationInfoId: Scalars['String'];
  /** Accreditation type */
  accreditationType?: InputMaybe<AccreditationType>;
  /** Residency country */
  country?: InputMaybe<Scalars['String']>;
  /** Expiration date for this info */
  expirationDate?: InputMaybe<Scalars['String']>;
};

export type UpdateBankAccountInput = {
  /** Bank identification number */
  IBAN?: InputMaybe<Scalars['String']>;
  /** Account name */
  accountName?: InputMaybe<Scalars['String']>;
  /** Account number */
  accountNumber?: InputMaybe<Scalars['String']>;
  /** Bank account id */
  bankAccountId: Scalars['String'];
  /** Bank name */
  bankName?: InputMaybe<Scalars['String']>;
  /** Bank identification number */
  benificiaryAddress?: InputMaybe<Scalars['String']>;
  /** Full address for bank branch */
  branchAddress?: InputMaybe<Scalars['String']>;
  /** Bank branch number */
  branchNumber?: InputMaybe<Scalars['String']>;
  /** the currencies the bank account will be used for. */
  currencies?: InputMaybe<Array<Scalars['String']>>;
  /** Is active */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Operator notes for this bank account */
  notes?: InputMaybe<Scalars['String']>;
  /** Routing Number /ABA */
  routingNumber?: InputMaybe<Scalars['String']>;
  /** Bank identification number */
  swift?: InputMaybe<Scalars['String']>;
};

export type UpdateDraftFilesInput = {
  /** file id */
  fileId: Scalars['String'];
  /** New locations for the file */
  newLocations?: InputMaybe<Array<FileLocationInput>>;
  /** New tags for the file */
  newTags?: InputMaybe<Array<FileTagsInput>>;
};

export type UpdateFundInput = {
  /** Fund closing date */
  closingDate?: InputMaybe<Scalars['DateTime']>;
  /** Fund currency */
  currency?: InputMaybe<Currency>;
  /** Fund description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Fund investments distribution */
  distributions?: InputMaybe<Array<ProjectPropertyDataInput>>;
  /** Fund unique Id */
  id: Scalars['String'];
  /** Fund inception date */
  inceptionDate?: InputMaybe<Scalars['DateTime']>;
  /** Investment classes for this fund */
  investmentClasses?: InputMaybe<Array<ProjectInvestmentClassesInput>>;
  /** Fund view type layout */
  layout?: InputMaybe<Array<LayoutDataInput>>;
  /** Fund name */
  name?: InputMaybe<Scalars['String']>;
  /** Related operator id */
  operatorId?: InputMaybe<Scalars['String']>;
  /** Project portfolio (for manual entry) */
  portfolio?: InputMaybe<Array<FundPortfolioDataInput>>;
  /** Fund properties ( distributions, assets, rents and et.c.) */
  properties?: InputMaybe<Array<ProjectPropertyInput>>;
  /** Fund status */
  status?: InputMaybe<ProjectStatus>;
};

export type UpdateFundProjectInput = {
  /** Project category */
  category?: InputMaybe<ProjectCategory>;
  /** Project currency */
  currency?: InputMaybe<Scalars['String']>;
  /** Project custom category */
  customCategory?: InputMaybe<Scalars['String']>;
  /** Fund project description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Project fund ref */
  fundId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  /** Project view type layout */
  layout?: InputMaybe<Array<LayoutDataInput>>;
  /** Project address location */
  location?: InputMaybe<ProjectLocationInput>;
  /** Project fund name */
  name?: InputMaybe<Scalars['String']>;
  /** Project portfolio (for manual entry) */
  portfolio?: InputMaybe<Array<ProjectPortfolioDataInput>>;
  /** Operator linked project */
  projectId?: InputMaybe<Scalars['String']>;
};

export type UpdateInvestmentInput = {
  /** Investment amount */
  amount?: InputMaybe<Scalars['Float']>;
  /** Investment commitment */
  commitment?: InputMaybe<Scalars['Float']>;
  /** Investment Contributions */
  contributions?: InputMaybe<Array<InvestmentContributionsInput>>;
  /** Investment Version */
  customizedStatistics?: InputMaybe<Array<StatisticsKeyValueInput>>;
  /** Investment date */
  date?: InputMaybe<Scalars['DateTime']>;
  /** Investment description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Investment Distributions */
  distributions?: InputMaybe<Array<InvestmentDistributionsInput>>;
  /** Defines the existing investor id and whether this is an existing investor (no need to update the investor legal entity) */
  existingInvestorId?: InputMaybe<Scalars['String']>;
  /** Investment exit date */
  exitDate?: InputMaybe<Scalars['DateTime']>;
  /** Investment unique Id */
  id: Scalars['String'];
  /** Invested by legal entity name (legal entity will be renamed if legalEntityUniqueId is matching some legal entity) */
  investedBy?: InputMaybe<Scalars['String']>;
  /** Investment class name */
  investmentClassName?: InputMaybe<Scalars['String']>;
  /** Investors emails (when updating this field investors won`t be removed => only new investors can be created). In order to update investors email for legal entity, updateLegalEntity mutation should be called */
  investorEmails?: InputMaybe<Array<Scalars['String']>>;
  /** Defines investment as contribution */
  isContribution?: InputMaybe<Scalars['Boolean']>;
  /** Invested by legal entity (Unique ID) */
  legalEntityUniqueId?: InputMaybe<Scalars['String']>;
  /** Investment holdings which was added manually for custom calculations */
  manualHoldings?: InputMaybe<Array<InvestmentHoldingInput>>;
  /** Investor operator name */
  name?: InputMaybe<Scalars['String']>;
  /** Investment operator unique Id */
  operatorId?: InputMaybe<Scalars['String']>;
  /** Investment percentage */
  percentage?: InputMaybe<Scalars['Float']>;
  /** Investment period time in months */
  period?: InputMaybe<Scalars['Float']>;
  /** Investor operator phone */
  phone?: InputMaybe<Scalars['String']>;
  /** Investment reference to project/fund */
  ref?: InputMaybe<Array<InvestmentRefInput>>;
  /** Investment sequence id */
  sequenceId?: InputMaybe<Scalars['Float']>;
  /** Investment type */
  type?: InputMaybe<InvestmentType>;
  /** Investment Version */
  version?: InputMaybe<Scalars['Float']>;
  /** Viewer emails */
  viewerEmails?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateOfferInput = {
  /** audience for getting the offering */
  audience?: InputMaybe<Array<ProspectInput>>;
  /** Offer category */
  category?: InputMaybe<ProjectCategory>;
  /** Offer currency */
  currency?: InputMaybe<Currency>;
  /** Offer custom category */
  customCategory?: InputMaybe<Scalars['String']>;
  /** Offering description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Offer unique Id */
  id: Scalars['String'];
  /** freely defined key value kpi the offering */
  kpis?: InputMaybe<Array<OfferKpiInput>>;
  /** Offer address location */
  location?: InputMaybe<ProjectLocationInput>;
  /** Offer name */
  name?: InputMaybe<Scalars['String']>;
  /** Offer publish date */
  offerPublishDate?: InputMaybe<Scalars['DateTime']>;
  /** Offer start date */
  offerStartDate?: InputMaybe<Scalars['DateTime']>;
  /** Related operator id */
  operatorId?: InputMaybe<Scalars['String']>;
  /** Offer status */
  status?: InputMaybe<OfferingStatusEnum>;
  /** Offer strategy */
  strategy?: InputMaybe<Scalars['String']>;
  /** Offer view mode */
  viewMode?: InputMaybe<ViewMode>;
};

export type UpdateOfferingActionsInput = {
  /** Offering Actions ids */
  ids: Array<Scalars['String']>;
  /** New status of the actions */
  status: ActionsStatusEnum;
};

export type UpdateOfferingActionsOperatorStatusInput = {
  /** Offering Actions ids */
  ids: Array<Scalars['String']>;
  /** New status of the operator actions */
  operatorStatus: ActionsOperatorStatusEnum;
};

export type UpdateOperatorAdminInput = {
  /** the contact link */
  contactLink?: InputMaybe<Scalars['String']>;
  /** the email */
  email?: InputMaybe<Scalars['String']>;
  /** the first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** The admin id */
  id: Scalars['String'];
  /** the first name */
  lastName?: InputMaybe<Scalars['String']>;
  /** the phone number */
  phone?: InputMaybe<Scalars['String']>;
  /** The role */
  role?: InputMaybe<AdminType>;
};

export type UpdateOperatorInput = {
  /** Operator contact list */
  contacts?: InputMaybe<Array<OperatorContactsInput>>;
  /** Operator description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Operator unique Id */
  id: Scalars['String'];
  /** Operator view type layout */
  layout?: InputMaybe<Array<LayoutDataInput>>;
  /** Operator official name */
  name?: InputMaybe<Scalars['String']>;
  /** Operator users */
  users?: InputMaybe<Array<Scalars['String']>>;
  /** Operator website address */
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateOperatorProjectInput = {
  /** Project calculation type */
  calculationType?: InputMaybe<CalculationType>;
  /** Project category */
  category?: InputMaybe<ProjectCategory>;
  /** Project end date */
  closingDate?: InputMaybe<Scalars['DateTime']>;
  /** Project currency */
  currency?: InputMaybe<Currency>;
  /** Project custom category */
  customCategory?: InputMaybe<Scalars['String']>;
  /** Project description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Project investments distribution */
  distributions?: InputMaybe<Array<ProjectPropertyDataInput>>;
  id: Scalars['String'];
  /** Project start date */
  inceptionDate?: InputMaybe<Scalars['DateTime']>;
  /** Investment classes for this project */
  investmentClasses?: InputMaybe<Array<ProjectInvestmentClassesInput>>;
  /** Project view type layout */
  layout?: InputMaybe<Array<LayoutDataInput>>;
  /** Project address location */
  location?: InputMaybe<ProjectLocationInput>;
  /** Project name */
  name?: InputMaybe<Scalars['String']>;
  /** Project operator ref */
  operatorId?: InputMaybe<Scalars['String']>;
  /** Project portfolio (for manual entry) */
  portfolio?: InputMaybe<Array<ProjectPortfolioDataInput>>;
  /** Project cancelation date */
  projectCancellationDate?: InputMaybe<Scalars['DateTime']>;
  /** Project properties ( distributions, assets, rents and et.c.) */
  properties?: InputMaybe<Array<ProjectPropertyInput>>;
  /** Project status */
  status?: InputMaybe<ProjectStatus>;
};

/** The updates reference (operator/project) */
export enum UpdateRef {
  /** This reference is related to the fund entity */
  FundId = 'fundId',
  /** This reference is related to the operator entity */
  OperatorId = 'operatorId',
  /** This reference is related to the project entity */
  ProjectId = 'projectId',
}

export type UpdateRefInput = {
  /** Update reference key (operator or project) */
  key: UpdateRef;
  /** Update reference value (operatorId or projectId) */
  value: Scalars['String'];
};

export type UpdateRefObject = {
  __typename?: 'UpdateRefObject';
  /** Update reference key (operator or project) */
  key: UpdateRef;
  /** Update reference value (operatorId or projectId) */
  value: Scalars['String'];
};

export type UpdateTaxInfoInput = {
  /** Social security number */
  SSN?: InputMaybe<Scalars['String']>;
  /** Tax identification number */
  TIN?: InputMaybe<Scalars['String']>;
  /** Full address for this legal entity */
  address?: InputMaybe<Scalars['String']>;
  /** Operator notes for this tax info */
  notes?: InputMaybe<Scalars['String']>;
  /** Tax info ID */
  taxInfoId: Scalars['String'];
};

export type UpdateUpdatesInput = {
  /** Update description */
  description?: InputMaybe<MultiLanObjectInput>;
  /** Update display flag for timeline */
  displayTimeline?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  /** the operatorId */
  operatorId?: InputMaybe<Scalars['String']>;
  /** Update progress */
  progress?: InputMaybe<Scalars['Float']>;
  /** Update reference (operatorId or projectId) */
  ref?: InputMaybe<UpdateRefInput>;
  /** Update report date */
  reportDate?: InputMaybe<Scalars['DateTime']>;
  /** Update status */
  status?: InputMaybe<Scalars['String']>;
  /** Multi language title */
  title?: InputMaybe<MultiLanObjectInput>;
};

export type UpdateUserInput = {
  /** User email */
  email?: InputMaybe<Scalars['String']>;
  /** User firstname */
  firstName?: InputMaybe<Scalars['String']>;
  /** User unique Id */
  id: Scalars['String'];
  /** User profile image */
  imgUrl?: InputMaybe<Scalars['String']>;
  /** User preffered language */
  language?: InputMaybe<Language>;
  /** User lastname */
  lastName?: InputMaybe<Scalars['String']>;
  /** User settings */
  settings?: InputMaybe<UserSettingsInput>;
};

export type UpdateUserLegalEntityInput = {
  /** Investor emails for this legal entity. If omit, nothing gets updated. Can remove investors completely by passing an empty array. Can throw errors if it is impossible to remove certain investors */
  investorEmails?: InputMaybe<Array<Scalars['String']>>;
  /** User legal entity name */
  name?: InputMaybe<Scalars['String']>;
  /** User legal entity unique identifier */
  uniqueId?: InputMaybe<Scalars['String']>;
  /** User legal entity ID */
  userLegalEntityId: Scalars['String'];
  /** Viewer emails for this legal entity. If omit, nothing gets updated. Can remove viewers by passing an empty array */
  viewerEmails?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateUserPreferenceQuestionInput = {
  /** Answers for this question */
  answers: Array<UserPreferenceAnswerInput>;
  /** Question text */
  question: Scalars['String'];
  /** Question ID */
  questionID: Scalars['String'];
};

export type UpdateUserPreferencesInput = {
  /** Currency preference list. Multichoice */
  currency?: InputMaybe<Array<Currency>>;
  /** A list of answers to custom operator questions */
  customAnswers?: InputMaybe<Array<CustomAnswerInput>>;
  /** Investment amount preference */
  investmentAmount?: InputMaybe<InvestmentAmountPreference>;
  /** Investment structure list. Multichoice */
  investmentStructure?: InputMaybe<Array<InvestmentStructurePreference>>;
  /** Investment type preferences list. Multichoice */
  investmentType?: InputMaybe<Array<InvestmentTypePreference>>;
  /** Risk-reward preferences. Multichoice */
  riskReward?: InputMaybe<Array<RiskRewardPreference>>;
  /** Investment strategy types. Multichoice */
  strategyType?: InputMaybe<Array<StrategyTypePreference>>;
  /** User legal entities IDs */
  userLegalEntityIDs: Array<Scalars['String']>;
};

export type Updates = {
  __typename?: 'Updates';
  /** Update description */
  description?: Maybe<MultiLanguage>;
  /** Update display flag for timeline */
  displayTimeline?: Maybe<Scalars['Boolean']>;
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Current status */
  entityStatus: ProjectPublish;
  /** Record unique Id */
  id: Scalars['String'];
  /** the operatorId */
  operatorId?: Maybe<Scalars['String']>;
  /** Update progress */
  progress?: Maybe<Scalars['Float']>;
  /** Update reference (operator or project) */
  ref: UpdateRefObject;
  /** Update report date */
  reportDate?: Maybe<Scalars['DateTime']>;
  /** Record start date */
  startDate: Scalars['DateTime'];
  /** Update status */
  status?: Maybe<Scalars['String']>;
  /** Multi language title */
  title?: Maybe<MultiLanguage>;
};

export type UserActiveUsers = {
  __typename?: 'UserActiveUsers';
  /** Published entities */
  publish: UserEntityStatus;
  /** Unpublished entities */
  unpublish: UserEntityStatus;
  /** Number of active user investors */
  userInvestor: Scalars['Float'];
  /** Number of active user operators */
  userOperator: Scalars['Float'];
};

export type UserActivity = {
  __typename?: 'UserActivity';
  /** Event log date */
  date: Scalars['DateTime'];
  /** Investor email */
  email: Scalars['String'];
  /** Log event type */
  eventType: Scalars['String'];
  /** User name (first name + last name) */
  name: Scalars['String'];
};

export type UserActivityInput = {
  /** Event types that should be selected */
  eventTypes?: InputMaybe<Array<Scalars['String']>>;
  /** Page size for pagination (20 is default) */
  limit?: InputMaybe<Scalars['Int']>;
  /** Search data starting from this offset (default is 0) */
  offset?: InputMaybe<Scalars['Int']>;
  /** Used to search through user names/emails */
  search?: InputMaybe<Scalars['String']>;
  /** Show events starting from this date */
  since?: InputMaybe<Scalars['DateTime']>;
};

export type UserActivityPage = {
  __typename?: 'UserActivityPage';
  records: Array<UserActivity>;
  total: Scalars['Int'];
};

/** The user differences on pre publishing entities */
export enum UserDiff {
  /** This is for operator accreditation info diffs (from user legal entities assigned to this operator) */
  AccreditationInfo = 'accreditationInfo',
  /** This is for operator bank account diffs (from user legal entities assigned to this operator) */
  BankAccount = 'bankAccount',
  /** This for operator fund diffs */
  Fund = 'fund',
  /** This for fund investment diffs */
  FundInvestment = 'fundInvestment',
  /** This for fund project diffs */
  FundProject = 'fundProject',
  /** This for fund update diffs */
  FundUpdate = 'fundUpdate',
  /** This is for operator legal entity diffs */
  LegalEntity = 'legalEntity',
  /** This for operator offer diffs */
  Offer = 'offer',
  /** This for operator diffs */
  Operator = 'operator',
  /** This for operator project diffs */
  OperatorProject = 'operatorProject',
  /** This for operator updates diffs */
  OperatorUpdate = 'operatorUpdate',
  /** This for project investment diffs */
  ProjectInvestment = 'projectInvestment',
  /** This for project updates diffs */
  ProjectUpdate = 'projectUpdate',
  /** This is for operator tax info diffs (from user legal entities assigned to this operator) */
  TaxInfo = 'taxInfo',
}

export type UserEntityStatus = {
  __typename?: 'UserEntityStatus';
  /** Number of active funds */
  funds: Scalars['Float'];
  /** Number of active investments */
  investments: Scalars['Float'];
  /** Number of active offers */
  offers: Scalars['Float'];
  /** Number of active operators */
  operators: Scalars['Float'];
  /** Number of active projects */
  projects: Scalars['Float'];
};

export type UserLegalEntity = {
  __typename?: 'UserLegalEntity';
  /** Accreditation information that was approved by operator. Operator can view/edit it, investor can only view it. Operator can only see unpublish version, investor => publish */
  approvedAccreditationInfo?: Maybe<AccreditationInfo>;
  /** Approved list of bank accounts. Operator can view/edit those values, but investor can only request changes. Operator can only see unpublish version, investor => publish */
  approvedBankAccounts: Array<BankAccount>;
  /** Tax info that was approved by operator. Operator can view/edit it, investor can request changes. Operator can only see unpublish version, investor => publish */
  approvedTaxInfo?: Maybe<TaxInfo>;
  /** Is this legal entity deceased */
  deceased?: Maybe<Scalars['Boolean']>;
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Current status */
  entityStatus: ProjectPublish;
  /** Record unique Id */
  id: Scalars['String'];
  /** Investments that were made by this legal entity */
  investments: Array<Investment>;
  /** User IDs that are assigned as investors to this legal entity */
  investorIDs: Array<Scalars['String']>;
  /** Users, that are assigned to this legal entity as investors */
  investors: Array<UserObject>;
  /** User IDs that belong to the sub admins managing the legal entity */
  managerIDs: Array<Scalars['String']>;
  /** User legal entity name */
  name: Scalars['String'];
  /** ID of the operator this legal entity is assigned to */
  operatorId: Scalars['String'];
  /** Accrediation info that wasn't yet approved by operator. Operator can view/edit it, investor can add new one. Operator can only see unpublish version, investor => publish */
  pendingAccreditationInfo?: Maybe<AccreditationInfo>;
  /** Non-approved bank accounts list. Investor requested changes are stored here. Operator can only see unpublish version, investor => publish */
  pendingBankAccounts: Array<BankAccount>;
  /** Tax info that wasn't yet approved by operator. Operator can view/edit it, investor can request changes to it. Operator can only see unpublish version, investor => publish */
  pendingTaxInfo?: Maybe<TaxInfo>;
  /** User IDs that are assigned as prospects to this legal entity */
  prospectIDs: Array<Scalars['String']>;
  /** Users, that are assigned as prospects to this legal entity */
  prospects: Array<UserObject>;
  /** Record start date */
  startDate: Scalars['DateTime'];
  /** User preferences, suggested by an operator. Only operator/admin can edit this */
  suggestedUserPreferences?: Maybe<UserPreference>;
  /** User legal entity unique identifier */
  uniqueId: Scalars['String'];
  /** List of custom operator question, that this user legal entity can give answers to. */
  userPreferenceCustomQuestions: Array<UserPreferenceQuestion>;
  /** User preferences, that were selected by investor. Investor/admin can edit this, but operator can only view it */
  userPreferences?: Maybe<UserPreference>;
  /** User IDs that are assigned as viewers to this legal entity */
  viewerIDs: Array<Scalars['String']>;
  /** Users, that can wiew this legal entity data */
  viewers: Array<UserObject>;
};

export type UserLegalEntityFilter = {
  /** Legal entities should be excluded, if those investors are present in them (only as investors) */
  excludedInvestorIDs?: InputMaybe<Array<Scalars['String']>>;
  /** Page size for pagination (20 is default) */
  limit?: InputMaybe<Scalars['Int']>;
  /** Search data starting from this offset (default is 0) */
  offset?: InputMaybe<Scalars['Int']>;
  /** Used to search through user legal entity names */
  search?: InputMaybe<Scalars['String']>;
};

export type UserLegalEntityPage = {
  __typename?: 'UserLegalEntityPage';
  records: Array<UserLegalEntity>;
  total: Scalars['Int'];
};

export type UserObject = {
  __typename?: 'UserObject';
  /** The type of the admin */
  adminType?: Maybe<AdminType>;
  /** Contact link */
  contactLink?: Maybe<Scalars['String']>;
  /** User email */
  email: Scalars['String'];
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** User firstname */
  firstName?: Maybe<Scalars['String']>;
  /** Record unique Id */
  id: Scalars['String'];
  /** User profile image URL */
  imgUrl?: Maybe<Scalars['String']>;
  /** User related investments */
  investmentDetails?: Maybe<Array<Investment>>;
  /** User accredited status */
  isAccredited?: Maybe<Scalars['Boolean']>;
  /** User preffered language */
  language?: Maybe<Language>;
  /** User lastname */
  lastName?: Maybe<Scalars['String']>;
  /** User related operators */
  operatorDetails?: Maybe<Array<Operator>>;
  /** User reference to profimex client entity */
  origin_ref?: Maybe<ProfimexRefObject>;
  /** Phone number */
  phone?: Maybe<Scalars['String']>;
  /** User role */
  role: UserRoles;
  /** User settings */
  settings?: Maybe<UserSettingsObject>;
  /** Record start date */
  startDate: Scalars['DateTime'];
  /**
   * This field will return a list of user legal entities to which current user is assigned as an investor/viewer/prospect.
   *     Restrictions:
   *     1. Investor can only see his own legal entities.
   *     2. Operator can only see legal entities, that were created by him
   */
  userLegalEntities: Array<UserLegalEntity>;
};

export type UserPreference = {
  __typename?: 'UserPreference';
  /** Investment currency list. Multichoice */
  currency: Array<Currency>;
  /** Custom answers, that were selected by investor or suggested by operator */
  customAnswers: Array<CustomAnswer>;
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Record unique Id */
  id: Scalars['String'];
  /** Investment amount preference */
  investmentAmount?: Maybe<InvestmentAmountPreference>;
  /** Investment structure list. Multichoice */
  investmentStructure: Array<InvestmentStructurePreference>;
  /** Investment type preferences list. Multichoice */
  investmentType: Array<InvestmentTypePreference>;
  /** Investment strategy types. Multichoice */
  isSuggestedByOperator: Scalars['Boolean'];
  /** Risk-reward preferences. Multichoice */
  riskReward: Array<RiskRewardPreference>;
  /** Record start date */
  startDate: Scalars['DateTime'];
  /** Investment strategy types. Multichoice */
  strategyType: Array<StrategyTypePreference>;
  /** User legal entity this preference list belongs to. This field is virtual (it is only available inside resolvers) */
  userLegalEntity: UserLegalEntity;
  /** User legal entity ID */
  userLegalEntityId: Scalars['String'];
};

export type UserPreferenceAnswer = {
  __typename?: 'UserPreferenceAnswer';
  /** Answer description, that is shown to investor */
  description: Scalars['String'];
  /** Answer key, that is used to identify this answer */
  key: Scalars['String'];
};

export type UserPreferenceAnswerInput = {
  /** Answer description, that is shown to investor */
  description: Scalars['String'];
  /** Answer key, that is used to identify this answer */
  key: Scalars['String'];
};

export type UserPreferenceQuestion = {
  __typename?: 'UserPreferenceQuestion';
  /** List of answers, that investor can select */
  answers: Array<UserPreferenceAnswer>;
  /** Record end date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Record unique Id */
  id: Scalars['String'];
  /** Operator */
  operator: Operator;
  /** Operator id */
  operatorId: Scalars['String'];
  /** Question text, that will be shown to investor */
  question: Scalars['String'];
  /** Record start date */
  startDate: Scalars['DateTime'];
};

export type UserPublishDiff = {
  __typename?: 'UserPublishDiff';
  description?: Maybe<Scalars['String']>;
  /** Returns JSON difference */
  diff: Scalars['JSON'];
  /** Provide entity id */
  id: Scalars['String'];
  /** Provide diff key */
  key: UserDiff;
  /** reference key with entity type name */
  refKey?: Maybe<Scalars['String']>;
  /** reference value with the id of the entity */
  refValue?: Maybe<Scalars['String']>;
};

export type UserPublishInput = {
  /** Provide entity id */
  id: Scalars['String'];
  /** Provide diff key */
  key: UserDiff;
  /** Notify by email */
  notify?: InputMaybe<Scalars['Boolean']>;
};

/** The supported user roles */
export enum UserRoles {
  /** This role has ADMIN priority and stored in Auth0 level */
  Admin = 'admin',
  /** This role has INVESTOR priorities stored in DB level */
  Investor = 'investor',
  /** This role has OPERATOR priorities stored in DB level */
  Operator = 'operator',
  /** This role has PROSPECT priority to received offers only */
  Prospect = 'prospect',
  /** This role has VISITOR priority to send us email after authorization */
  Visitor = 'visitor',
}

export type UserSettingsInput = {
  /** Marketing agreement */
  marketing?: InputMaybe<Scalars['Boolean']>;
  /** Terms agreement */
  terms?: InputMaybe<Scalars['Boolean']>;
  /** Use sms for two factor auth (via AUTH0) */
  use_mfa?: InputMaybe<Scalars['Boolean']>;
};

export type UserSettingsObject = {
  __typename?: 'UserSettingsObject';
  /** Marketing agreement */
  marketing?: Maybe<Scalars['Boolean']>;
  /** Terms agreement */
  terms?: Maybe<Scalars['Boolean']>;
  /** Use sms for two factor auth (via AUTH0) */
  use_mfa?: Maybe<Scalars['Boolean']>;
};

/** The main list of offering view mode */
export enum ViewMode {
  /** Open mode shows all available data the offering */
  Open = 'OPEN',
  /** Restricted mode shows no financial numbers beside minimum investment */
  Restricted = 'RESTRICTED',
}

export type UserSettingsFragmentFragment = {
  __typename?: 'UserSettingsObject';
  marketing?: boolean | null;
  terms?: boolean | null;
  use_mfa?: boolean | null;
};

export type UpdatesFragmentFragment = {
  __typename?: 'Updates';
  reportDate?: string | null;
  progress?: number | null;
  status?: string | null;
  id: string;
  displayTimeline?: boolean | null;
  description?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
  title?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
};

export type AudienceFragmentFragment = {
  __typename?: 'ProspectObject';
  email: string;
  role: UserRoles;
  firstName?: string | null;
  lastName?: string | null;
  language?: Language | null;
};

export type LocationFragmentFragment = {
  __typename?: 'ProjectLocationObject';
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
};

export type EntityPropertiesFragmentFragment = {
  __typename?: 'ProjectPropertyObject';
  key: ProjectProperty;
  series1Legend?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
  series2Legend?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
  value: Array<{
    __typename?: 'ProjectPropertyDataObject';
    date?: string | null;
    value?: number | null;
    projected?: number | null;
    title?: string | null;
    annotation?: string | null;
  }>;
};

export type TaxInfoFragmentFragment = {
  __typename: 'TaxInfo';
  id: string;
  address?: string | null;
  endDate?: string | null;
  notes?: string | null;
  SSN?: string | null;
  startDate: string;
  status: InformationStatus;
  TIN?: string | null;
};

export type UserPreferenceFragmentFragment = {
  __typename: 'UserPreference';
  id: string;
  startDate: string;
  endDate?: string | null;
  investmentAmount?: InvestmentAmountPreference | null;
  currency: Array<Currency>;
  investmentStructure: Array<InvestmentStructurePreference>;
  investmentType: Array<InvestmentTypePreference>;
  isSuggestedByOperator: boolean;
  riskReward: Array<RiskRewardPreference>;
  strategyType: Array<StrategyTypePreference>;
  userLegalEntityId: string;
  customAnswers: Array<{
    __typename: 'CustomAnswer';
    questionID: string;
    selectedAnswers: Array<string>;
    question: { __typename?: 'UserPreferenceQuestion'; question: string };
  }>;
};

export type AccreditationInfoFragmentFragment = {
  __typename: 'AccreditationInfo';
  id: string;
  endDate?: string | null;
  accreditationType: AccreditationType;
  startDate: string;
  status: InformationStatus;
  country: string;
  expirationDate?: string | null;
};

export type BankAccountFragmentFragment = {
  __typename: 'BankAccount';
  id: string;
  accountName?: string | null;
  isActive: boolean;
  notes?: string | null;
  startDate: string;
  status: InformationStatus;
  accountNumber?: string | null;
  approvedBankAccountId?: string | null;
  bankName?: string | null;
  currencies?: Array<string> | null;
  IBAN?: string | null;
  swift?: string | null;
  routingNumber?: string | null;
  benificiaryAddress?: string | null;
  branchAddress?: string | null;
  branchNumber?: string | null;
  endDate?: string | null;
};

export type UserLegalEntityFragmentFragment = {
  __typename: 'UserLegalEntity';
  id: string;
  endDate?: string | null;
  startDate: string;
  name: string;
  uniqueId: string;
  viewerIDs: Array<string>;
  investorIDs: Array<string>;
  operatorId: string;
};

export type InvestmentClassFragmentFragment = {
  __typename?: 'OperatorProject';
  investmentClasses?: Array<{
    __typename?: 'ProjectInvestmentClassesObject';
    name: string;
    type?: InvestmentClassEnum | null;
    distributionPeriod?: string | null;
    percentage?: number | null;
    allocationAmount?: number | null;
    currency?: Currency | null;
    endDate?: string | null;
    extensionOptionDate?: string | null;
    isCompounding?: boolean | null;
  }> | null;
};

export type InvestmentClassFragmentFundFragment = {
  __typename?: 'Fund';
  investmentClasses?: Array<{
    __typename?: 'ProjectInvestmentClassesObject';
    name: string;
    type?: InvestmentClassEnum | null;
    distributionPeriod?: string | null;
    percentage?: number | null;
    allocationAmount?: number | null;
    currency?: Currency | null;
    endDate?: string | null;
    extensionOptionDate?: string | null;
    isCompounding?: boolean | null;
  }> | null;
};

export type InvestmentFragmentFragment = {
  __typename?: 'Investment';
  amount?: number | null;
  commitment?: number | null;
  date?: string | null;
  email: Array<string>;
  sequenceId?: number | null;
  id: string;
  investedBy: string;
  operatorId: string;
  percentage?: number | null;
  period?: number | null;
  exitDate?: string | null;
  isContribution?: boolean | null;
  type: InvestmentType;
  version?: number | null;
  distributions?: Array<{
    __typename?: 'InvestmentDistributionsObject';
    investmentClassType?: InvestmentClassEnum | null;
    date?: string | null;
    payDueDate?: string | null;
    amount?: number | null;
    currency?: Currency | null;
    currencyRate?: number | null;
    override?: boolean | null;
    expenses?: number | null;
    notes?: string | null;
    paymentComponent?: PaymentComponentEnum | null;
    distributionPeriod?: string | null;
  }> | null;
  contributions?: Array<{
    __typename?: 'InvestmentContributionsObject';
    date?: string | null;
    closingDate?: string | null;
    contribution?: number | null;
    commitment?: number | null;
    capitalCall?: number | null;
    currency?: Currency | null;
    currencyRate?: number | null;
    percentage?: number | null;
    override?: boolean | null;
    investmentClassName?: string | null;
    notes?: string | null;
  }> | null;
  description?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
  manualHoldings?: Array<{
    __typename?: 'InvestmentHoldingObject';
    date?: string | null;
    value?: string | null;
  }> | null;
  holdings?: Array<{
    __typename?: 'InvestmentHoldingObject';
    date?: string | null;
    value?: string | null;
  }> | null;
  customizedStatistics?: Array<{
    __typename?: 'StatisticsKeyValue';
    key?: string | null;
    value?: string | null;
  }> | null;
  ref: Array<{ __typename?: 'InvestmentRefObject'; key: InvestmentRef; value: string }>;
};

export type LayoutFragmentFragment = {
  __typename?: 'LayoutDataObject';
  key?: Layout | null;
  value?: Array<string> | null;
};

export type GetAllCurrencyRatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllCurrencyRatesQuery = {
  __typename?: 'Query';
  allCurrencyRates: Array<{
    __typename?: 'CurrencyExchange';
    date?: string | null;
    currencyRates?: {
      __typename?: 'CurrencyRatesObject';
      CHF_USD?: number | null;
      EUR_USD?: number | null;
      GBP_USD?: number | null;
      ILS_USD?: number | null;
      CAD_USD?: number | null;
    } | null;
  }>;
};

export type GetCurrencyRatesQueryVariables = Exact<{
  date?: InputMaybe<Scalars['String']>;
}>;

export type GetCurrencyRatesQuery = {
  __typename?: 'Query';
  currencyRates: {
    __typename?: 'CurrencyRatesObject';
    CHF_USD?: number | null;
    EUR_USD?: number | null;
    GBP_USD?: number | null;
    ILS_USD?: number | null;
  };
};

export type GetServiceQueryVariables = Exact<{ [key: string]: never }>;

export type GetServiceQuery = { __typename?: 'Query'; getVersion?: string | null };

export type GetThemeQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type GetThemeQuery = {
  __typename?: 'Query';
  getTheme: {
    __typename?: 'Theme';
    colors?: {
      __typename?: 'ColorObject';
      primary: string;
      secondary: string;
      button: string;
      title: string;
      icons: string;
      selectedIcon: string;
    } | null;
    barColors?: {
      __typename?: 'BarColorObject';
      barA: string;
      barAOpacity: string;
      barB: string;
      barBOpacity: string;
      barC: string;
      barCOpacity: string;
      barD: string;
      barDOpacity: string;
    } | null;
    pieColors?: {
      __typename?: 'PieColorObject';
      colorA: string;
      colorB: string;
      colorC: string;
      colorD: string;
      colorE: string;
      colorF: string;
      colorG: string;
      colorH: string;
      colorI: string;
      colorJ: string;
    } | null;
    kpiColors?: {
      __typename?: 'KpiColorObject';
      contribution: string;
      contributionIcon: string;
      distribution: string;
      distributionIcon: string;
      commitmentIcon: string;
      commitment: string;
      openCommitments: string;
      openCommitmentsIcon: string;
      transfer: string;
      transferIcon: string;
      custom1: string;
      custom1Icon: string;
      custom2: string;
      custom2Icon: string;
      custom3: string;
      custom3Icon: string;
      custom4: string;
      custom4Icon: string;
      custom5: string;
      custom5Icon: string;
    } | null;
    kpiNames?: {
      __typename?: 'KpiNamesObject';
      contribution: string;
      distribution: string;
      commitment: string;
      openCommitments: string;
      transfer: string;
      investedCapital: string;
      accumulatedInterest: string;
      equityPercentage: string;
      category: string;
    } | null;
    categoryColors?: {
      __typename?: 'CategoryColorObject';
      colors: Array<{ __typename?: 'KeyValueObject'; key: string; value: string }>;
    } | null;
    fonts?: { __typename?: 'FontsObject'; boldFont: string; mainFont: string } | null;
  };
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = { __typename?: 'Mutation'; logout: boolean };

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser: { __typename?: 'UserObject'; language?: Language | null };
};

export type UpdateUserSettingsMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;

export type UpdateUserSettingsMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'UserObject';
    settings?: {
      __typename?: 'UserSettingsObject';
      marketing?: boolean | null;
      terms?: boolean | null;
      use_mfa?: boolean | null;
    } | null;
  };
};

export type GetLastTransactionQueryVariables = Exact<{ [key: string]: never }>;

export type GetLastTransactionQuery = { __typename?: 'Query'; getLastUpdated: string };

export type GetManagerDetailsQueryVariables = Exact<{
  filterId: Scalars['String'];
  investorId: Scalars['String'];
}>;

export type GetManagerDetailsQuery = {
  __typename?: 'Query';
  getManagerDetails: Array<{
    __typename?: 'UserObject';
    firstName?: string | null;
    lastName?: string | null;
    email: string;
    phone?: string | null;
    contactLink?: string | null;
    id: string;
  }>;
};

export type GetInvestorOfferingQueryVariables = Exact<{ [key: string]: never }>;

export type GetInvestorOfferingQuery = {
  __typename?: 'Query';
  findAllPublicOffers: Array<{
    __typename?: 'Offer';
    operatorId: string;
    id: string;
    name?: string | null;
    category?: ProjectCategory | null;
    customCategory?: string | null;
    strategy?: string | null;
    offerStartDate?: string | null;
    description?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
    location?: {
      __typename?: 'ProjectLocationObject';
      address?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
    kpis?: Array<{
      __typename?: 'OfferKpiObject';
      key?: string | null;
      value?: string | null;
    }> | null;
  }>;
};

export type GetUpdateOfferingActionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetUpdateOfferingActionsQuery = {
  __typename?: 'Query';
  requestAllPublicOfferingActions: Array<{
    __typename?: 'ActionsEntity';
    offeringId: string;
    status: ActionsStatusEnum;
    actionRef?: any | null;
    operatorId?: string | null;
    userId?: string | null;
    id: string;
    popUpsShown?: number | null;
    user: { __typename?: 'UserObject'; email: string; id: string };
    offering: {
      __typename?: 'Offer';
      id: string;
      name?: string | null;
      status?: OfferingStatusEnum | null;
      operatorId: string;
      kpis?: Array<{
        __typename?: 'OfferKpiObject';
        key?: string | null;
        value?: string | null;
      }> | null;
    };
  }>;
};

export type FindAllPublicOffersByOperatorQueryVariables = Exact<{ [key: string]: never }>;

export type FindAllPublicOffersByOperatorQuery = {
  __typename?: 'Query';
  findAllPublicOffersByOperator: Array<{
    __typename?: 'Offer';
    operatorId: string;
    id: string;
    name?: string | null;
    category?: ProjectCategory | null;
    customCategory?: string | null;
    strategy?: string | null;
    offerStartDate?: string | null;
    description?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
    location?: {
      __typename?: 'ProjectLocationObject';
      address?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
    kpis?: Array<{
      __typename?: 'OfferKpiObject';
      key?: string | null;
      value?: string | null;
    }> | null;
  }>;
};

export type GetProfimexOverviewQueryVariables = Exact<{
  investorIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;

export type GetProfimexOverviewQuery = {
  __typename?: 'Query';
  getProfimexInvestorOverviewData: Array<{
    __typename?: 'ProfimexOverview';
    investorId?: string | null;
    activeInvestments?: number | null;
    totalDistribution?: number | null;
    openCommitments?: number | null;
    currency?: string | null;
    updateDate?: string | null;
    activeInvestmentsUSD?: number | null;
    totalDistributionUSD?: number | null;
    openCommitmentsUSD?: number | null;
  }>;
};

export type GetProfimexTransactionsQueryVariables = Exact<{
  investorId: Scalars['String'];
}>;

export type GetProfimexTransactionsQuery = {
  __typename?: 'Query';
  getInvestorTransactions: Array<{
    __typename?: 'ProfimexTransaction';
    id: string;
    fullNameEng: string;
    fullNameHeb: string;
    createdDate?: string | null;
    exchangeDate?: string | null;
    type: TransactionType;
    startDate: string;
    currency: string;
    amount: number;
    localAmount: number;
    projectId?: string | null;
    notes?: string | null;
    announcement: boolean;
    transactionNotes: string;
    transactionNotesEng: string;
    subTx?: string | null;
    mainSubTx?: string | null;
    origin_ref?: {
      __typename?: 'OriginRef';
      clientId?: string | null;
      transactionId?: string | null;
    } | null;
  }>;
};

export type GetUserInvestorQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserInvestorQuery = {
  __typename?: 'Query';
  findCurrentUser?: {
    __typename?: 'UserObject';
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    language?: Language | null;
    email: string;
    role: UserRoles;
    settings?: {
      __typename?: 'UserSettingsObject';
      marketing?: boolean | null;
      terms?: boolean | null;
      use_mfa?: boolean | null;
    } | null;
    userLegalEntities: Array<{
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      investorIDs: Array<string>;
      deceased?: boolean | null;
      viewerIDs: Array<string>;
      operatorId: string;
      uniqueId: string;
      managerIDs: Array<string>;
      approvedTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
      pendingTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
      approvedAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
      pendingAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
      approvedBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
      pendingBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
      userPreferences?: {
        __typename: 'UserPreference';
        id: string;
        startDate: string;
        endDate?: string | null;
        investmentAmount?: InvestmentAmountPreference | null;
        currency: Array<Currency>;
        investmentStructure: Array<InvestmentStructurePreference>;
        investmentType: Array<InvestmentTypePreference>;
        isSuggestedByOperator: boolean;
        riskReward: Array<RiskRewardPreference>;
        strategyType: Array<StrategyTypePreference>;
        userLegalEntityId: string;
        customAnswers: Array<{
          __typename: 'CustomAnswer';
          questionID: string;
          selectedAnswers: Array<string>;
          question: { __typename?: 'UserPreferenceQuestion'; question: string };
        }>;
      } | null;
      suggestedUserPreferences?: {
        __typename: 'UserPreference';
        id: string;
        startDate: string;
        endDate?: string | null;
        investmentAmount?: InvestmentAmountPreference | null;
        currency: Array<Currency>;
        investmentStructure: Array<InvestmentStructurePreference>;
        investmentType: Array<InvestmentTypePreference>;
        isSuggestedByOperator: boolean;
        riskReward: Array<RiskRewardPreference>;
        strategyType: Array<StrategyTypePreference>;
        userLegalEntityId: string;
        customAnswers: Array<{
          __typename: 'CustomAnswer';
          questionID: string;
          selectedAnswers: Array<string>;
          question: { __typename?: 'UserPreferenceQuestion'; question: string };
        }>;
      } | null;
      userPreferenceCustomQuestions: Array<{
        __typename?: 'UserPreferenceQuestion';
        id: string;
        question: string;
        answers: Array<{ __typename?: 'UserPreferenceAnswer'; description: string; key: string }>;
      }>;
    }>;
    investmentDetails?: Array<{
      __typename?: 'Investment';
      legalEntityId: string;
      amount?: number | null;
      email: Array<string>;
      percentage?: number | null;
      period?: number | null;
      exitDate?: string | null;
      isContribution?: boolean | null;
      type: InvestmentType;
      id: string;
      date?: string | null;
      investedBy: string;
      commitment?: number | null;
      netRoi?: number | null;
      grossRoi?: number | null;
      netIrr?: number | null;
      grossIrr?: number | null;
      netCoc?: number | null;
      grossCoc?: number | null;
      sequenceId?: number | null;
      operatorId: string;
      version?: number | null;
      customizedStatistics?: Array<{
        __typename?: 'StatisticsKeyValue';
        key?: string | null;
        value?: string | null;
      }> | null;
      ref: Array<{ __typename?: 'InvestmentRefObject'; key: InvestmentRef; value: string }>;
      holdings?: Array<{
        __typename?: 'InvestmentHoldingObject';
        date?: string | null;
        value?: string | null;
      }> | null;
      manualHoldings?: Array<{
        __typename?: 'InvestmentHoldingObject';
        date?: string | null;
        value?: string | null;
      }> | null;
      operatorDetails?: {
        __typename?: 'Operator';
        id: string;
        name?: string | null;
        isUnderMaintenance?: boolean | null;
        websiteUrl?: string | null;
        overviewKpisCategories: Array<string>;
        description?: {
          __typename?: 'MultiLanguage';
          en?: string | null;
          heb?: string | null;
        } | null;
        layout?: Array<{
          __typename?: 'LayoutDataObject';
          key?: Layout | null;
          value?: Array<string> | null;
        }> | null;
        contacts?: Array<{
          __typename?: 'OperatorContactsObject';
          fax?: string | null;
          main?: boolean | null;
          name?: string | null;
          phone?: string | null;
          mobile?: string | null;
          email?: string | null;
        }> | null;
        updatesDetails?: Array<{
          __typename?: 'Updates';
          reportDate?: string | null;
          progress?: number | null;
          status?: string | null;
          id: string;
          displayTimeline?: boolean | null;
          description?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          title?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
        }> | null;
        offerDetails?: Array<{
          __typename?: 'Offer';
          category?: ProjectCategory | null;
          customCategory?: string | null;
          id: string;
          name?: string | null;
          operatorId: string;
          description?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          location?: {
            __typename?: 'ProjectLocationObject';
            address?: string | null;
            latitude?: number | null;
            longitude?: number | null;
          } | null;
        }> | null;
      } | null;
      projectDetails?: {
        __typename?: 'OperatorProject';
        id: string;
        category?: ProjectCategory | null;
        customCategory?: string | null;
        currency?: Currency | null;
        calculationType?: CalculationType | null;
        inceptionDate?: string | null;
        closingDate?: string | null;
        operatorId: string;
        status?: ProjectStatus | null;
        kpis?: Array<string> | null;
        name?: string | null;
        description?: {
          __typename?: 'MultiLanguage';
          en?: string | null;
          heb?: string | null;
        } | null;
        layout?: Array<{
          __typename?: 'LayoutDataObject';
          key?: Layout | null;
          value?: Array<string> | null;
        }> | null;
        portfolio?: Array<{
          __typename?: 'ProjectPortfolioDataObject';
          key?: string | null;
          value?: string | null;
        }> | null;
        location?: {
          __typename?: 'ProjectLocationObject';
          address?: string | null;
          latitude?: number | null;
          longitude?: number | null;
        } | null;
        updatesDetails?: Array<{
          __typename?: 'Updates';
          reportDate?: string | null;
          progress?: number | null;
          status?: string | null;
          id: string;
          displayTimeline?: boolean | null;
          description?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          title?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
        }> | null;
        properties?: Array<{
          __typename?: 'ProjectPropertyObject';
          key: ProjectProperty;
          series1Legend?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          series2Legend?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          value: Array<{
            __typename?: 'ProjectPropertyDataObject';
            date?: string | null;
            value?: number | null;
            projected?: number | null;
            title?: string | null;
            annotation?: string | null;
          }>;
        }> | null;
        investmentClasses?: Array<{
          __typename?: 'ProjectInvestmentClassesObject';
          name: string;
          type?: InvestmentClassEnum | null;
          distributionPeriod?: string | null;
          percentage?: number | null;
          allocationAmount?: number | null;
          currency?: Currency | null;
          endDate?: string | null;
          extensionOptionDate?: string | null;
          isCompounding?: boolean | null;
        }> | null;
      } | null;
      fundDetails?: {
        __typename?: 'Fund';
        id: string;
        name?: string | null;
        inceptionDate?: string | null;
        operatorId: string;
        status?: ProjectStatus | null;
        currency?: Currency | null;
        description?: {
          __typename?: 'MultiLanguage';
          en?: string | null;
          heb?: string | null;
        } | null;
        layout?: Array<{
          __typename?: 'LayoutDataObject';
          key?: Layout | null;
          value?: Array<string> | null;
        }> | null;
        portfolio?: Array<{
          __typename?: 'FundPortfolioDataObject';
          key?: string | null;
          value?: string | null;
          group?: string | null;
        }> | null;
        projectDetails?: Array<{
          __typename?: 'FundProject';
          category?: ProjectCategory | null;
          customCategory?: string | null;
          name?: string | null;
          fundId: string;
          operatorId?: string | null;
          id: string;
          description?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          portfolio?: Array<{
            __typename?: 'ProjectPortfolioDataObject';
            key?: string | null;
            value?: string | null;
          }> | null;
          location?: {
            __typename?: 'ProjectLocationObject';
            address?: string | null;
            latitude?: number | null;
            longitude?: number | null;
          } | null;
        }> | null;
        updatesDetails?: Array<{
          __typename?: 'Updates';
          reportDate?: string | null;
          progress?: number | null;
          status?: string | null;
          id: string;
          displayTimeline?: boolean | null;
          description?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          title?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
        }> | null;
        properties?: Array<{
          __typename?: 'ProjectPropertyObject';
          key: ProjectProperty;
          series1Legend?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          series2Legend?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          value: Array<{
            __typename?: 'ProjectPropertyDataObject';
            date?: string | null;
            value?: number | null;
            projected?: number | null;
            title?: string | null;
            annotation?: string | null;
          }>;
        }> | null;
        investmentClasses?: Array<{
          __typename?: 'ProjectInvestmentClassesObject';
          name: string;
          type?: InvestmentClassEnum | null;
          distributionPeriod?: string | null;
          percentage?: number | null;
          allocationAmount?: number | null;
          currency?: Currency | null;
          endDate?: string | null;
          extensionOptionDate?: string | null;
          isCompounding?: boolean | null;
        }> | null;
      } | null;
      distributions?: Array<{
        __typename?: 'InvestmentDistributionsObject';
        investmentClassType?: InvestmentClassEnum | null;
        date?: string | null;
        payDueDate?: string | null;
        amount?: number | null;
        currency?: Currency | null;
        currencyRate?: number | null;
        override?: boolean | null;
        expenses?: number | null;
        notes?: string | null;
        paymentComponent?: PaymentComponentEnum | null;
        distributionPeriod?: string | null;
      }> | null;
      contributions?: Array<{
        __typename?: 'InvestmentContributionsObject';
        date?: string | null;
        closingDate?: string | null;
        contribution?: number | null;
        commitment?: number | null;
        capitalCall?: number | null;
        currency?: Currency | null;
        currencyRate?: number | null;
        percentage?: number | null;
        override?: boolean | null;
        investmentClassName?: string | null;
        notes?: string | null;
      }> | null;
      description?: {
        __typename?: 'MultiLanguage';
        en?: string | null;
        heb?: string | null;
      } | null;
    }> | null;
  } | null;
};

export type UpdateOfferingActionsMutationVariables = Exact<{
  input: UpdateOfferingActionsInput;
}>;

export type UpdateOfferingActionsMutation = {
  __typename?: 'Mutation';
  updateOfferingActions: Array<{
    __typename?: 'ActionsEntity';
    offeringId: string;
    status: ActionsStatusEnum;
    actionRef?: any | null;
    operatorId?: string | null;
    userId?: string | null;
    id: string;
    popUpsShown?: number | null;
    user: { __typename?: 'UserObject'; email: string; id: string };
    offering: {
      __typename?: 'Offer';
      id: string;
      name?: string | null;
      status?: OfferingStatusEnum | null;
      operatorId: string;
    };
  }>;
};

export type ServerFilesDraftProjectFundInvestorQueryVariables = Exact<{
  input: GetInvestorPublicProjectFundFileInput;
}>;

export type ServerFilesDraftProjectFundInvestorQuery = {
  __typename?: 'Query';
  getInvestorDraftProjectsFundsFiles: Array<{
    __typename?: 'DraftFile';
    id: string;
    fileName?: string | null;
    content?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    thumbnail?: string | null;
    shared?: boolean | null;
    status?: string | null;
    size?: number | null;
    url?: string | null;
    projectId?: string | null;
    fundId?: string | null;
    portfolioId?: string | null;
    offeringId?: string | null;
    operatorId?: string | null;
    version?: string | null;
    tags?: Array<{
      __typename?: 'FileTags';
      extra?: string | null;
      value?: string | null;
      type?: FileTagEnum | null;
      hidden?: boolean | null;
      legalEntityId?: string | null;
    }> | null;
    locations?: Array<{
      __typename?: 'FileLocation';
      entityId?: string | null;
      entityType?: FileEntityTypeEnum | null;
      locationInPage?: FileLocationEnum | null;
      locationInnerId?: string | null;
      sortIndex?: number | null;
    }> | null;
  }>;
};

export type FindCurrentOperatorsQueryVariables = Exact<{ [key: string]: never }>;

export type FindCurrentOperatorsQuery = {
  __typename?: 'Query';
  findCurrentOperators?: Array<{
    __typename?: 'Operator';
    id: string;
    name?: string | null;
    websiteUrl?: string | null;
    overviewKpisCategories: Array<string>;
    description?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
    contacts?: Array<{
      __typename?: 'OperatorContactsObject';
      fax?: string | null;
      main?: boolean | null;
      name?: string | null;
      phone?: string | null;
      mobile?: string | null;
      email?: string | null;
    }> | null;
    updatesDetails?: Array<{
      __typename?: 'Updates';
      reportDate?: string | null;
      progress?: number | null;
      status?: string | null;
      id: string;
      displayTimeline?: boolean | null;
      description?: {
        __typename?: 'MultiLanguage';
        en?: string | null;
        heb?: string | null;
      } | null;
      title?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
    }> | null;
    offerDetails?: Array<{
      __typename?: 'Offer';
      category?: ProjectCategory | null;
      customCategory?: string | null;
      id: string;
      name?: string | null;
      operatorId: string;
      description?: {
        __typename?: 'MultiLanguage';
        en?: string | null;
        heb?: string | null;
      } | null;
      location?: {
        __typename?: 'ProjectLocationObject';
        address?: string | null;
        latitude?: number | null;
        longitude?: number | null;
      } | null;
    }> | null;
  }> | null;
};

export type ApproveAccreditationInfoMutationVariables = Exact<{
  input: ApproveAccreditationInfoInput;
}>;

export type ApproveAccreditationInfoMutation = {
  __typename?: 'Mutation';
  approveAccreditationInfo: {
    __typename?: 'AccreditationInfo';
    id: string;
    userLegalEntity: {
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      approvedAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
      pendingAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
    };
  };
};

export type CreateAccreditationInfoMutationVariables = Exact<{
  input: CreateAccreditationInfoInput;
}>;

export type CreateAccreditationInfoMutation = {
  __typename?: 'Mutation';
  createAccreditationInfo: {
    __typename?: 'AccreditationInfo';
    id: string;
    userLegalEntity: {
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      approvedAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
      pendingAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
    };
  };
};

export type GetAccreditationInfoQueryVariables = Exact<{
  investorID: Scalars['String'];
}>;

export type GetAccreditationInfoQuery = {
  __typename?: 'Query';
  findInvestorUser: {
    __typename?: 'UserObject';
    id: string;
    userLegalEntities: Array<{
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      operatorId: string;
      approvedAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
      pendingAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
    }>;
  };
};

export type RequestAccreditationInfoApprovalMutationVariables = Exact<{
  input: RequestAccreditationInfoApprovalInput;
}>;

export type RequestAccreditationInfoApprovalMutation = {
  __typename?: 'Mutation';
  requestAccreditationInfoApproval: {
    __typename?: 'AccreditationInfo';
    id: string;
    userLegalEntity: {
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      approvedAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
      pendingAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
    };
  };
};

export type UpdateAccreditationInfoMutationVariables = Exact<{
  input: UpdateAccreditationInfoInput;
}>;

export type UpdateAccreditationInfoMutation = {
  __typename?: 'Mutation';
  updateAccreditationInfo: {
    __typename?: 'AccreditationInfo';
    id: string;
    userLegalEntity: {
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      approvedAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
      pendingAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
    };
  };
};

export type CreateBankAccountMutationVariables = Exact<{
  input: CreateBankAccountInput;
}>;

export type CreateBankAccountMutation = {
  __typename?: 'Mutation';
  createBankAccount: {
    __typename?: 'BankAccount';
    id: string;
    userLegalEntity: {
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      approvedBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
      pendingBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
    };
  };
};

export type GetBankAccountsQueryVariables = Exact<{
  investorID: Scalars['String'];
}>;

export type GetBankAccountsQuery = {
  __typename?: 'Query';
  findInvestorUser: {
    __typename?: 'UserObject';
    id: string;
    userLegalEntities: Array<{
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      operatorId: string;
      pendingBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
      approvedBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
    }>;
  };
};

export type RequestBankAccountApprovalMutationVariables = Exact<{
  input: RequestBankAccountApprovalInput;
}>;

export type RequestBankAccountApprovalMutation = {
  __typename?: 'Mutation';
  requestBankAccountApproval: {
    __typename?: 'BankAccount';
    id: string;
    userLegalEntity: {
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      approvedBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
      pendingBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
    };
  };
};

export type RequestBankAccountChangesMutationVariables = Exact<{
  input: RequestBankAccountChangesInput;
}>;

export type RequestBankAccountChangesMutation = {
  __typename?: 'Mutation';
  requestBankAccountChanges: {
    __typename?: 'BankAccount';
    id: string;
    userLegalEntity: {
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      approvedBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
      pendingBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
    };
  };
};

export type UpdateBankAccountMutationVariables = Exact<{
  input: UpdateBankAccountInput;
}>;

export type UpdateBankAccountMutation = {
  __typename?: 'Mutation';
  updateBankAccount: {
    __typename?: 'BankAccount';
    id: string;
    userLegalEntity: {
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      approvedBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
      pendingBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
    };
  };
};

export type ServerFilesQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type ServerFilesQuery = {
  __typename?: 'Query';
  getDraftFilesByIds: Array<{
    __typename?: 'DraftFile';
    id: string;
    fileName?: string | null;
    content?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    thumbnail?: string | null;
    shared?: boolean | null;
    status?: string | null;
    size?: number | null;
    url?: string | null;
    projectId?: string | null;
    fundId?: string | null;
    portfolioId?: string | null;
    offeringId?: string | null;
    operatorId?: string | null;
    version?: string | null;
    tags?: Array<{
      __typename?: 'FileTags';
      extra?: string | null;
      value?: string | null;
      type?: FileTagEnum | null;
      hidden?: boolean | null;
      legalEntityId?: string | null;
    }> | null;
    locations?: Array<{
      __typename?: 'FileLocation';
      entityId?: string | null;
      entityType?: FileEntityTypeEnum | null;
      locationInPage?: FileLocationEnum | null;
      locationInnerId?: string | null;
      sortIndex?: number | null;
    }> | null;
  }>;
};

export type ServerFilesInvestorQueryVariables = Exact<{
  input: GetInvestorDraftFilesInput;
}>;

export type ServerFilesInvestorQuery = {
  __typename?: 'Query';
  getInvestorDraftFiles: Array<{
    __typename?: 'DraftFile';
    id: string;
    fileName?: string | null;
    content?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    thumbnail?: string | null;
    shared?: boolean | null;
    status?: string | null;
    size?: number | null;
    url?: string | null;
    projectId?: string | null;
    fundId?: string | null;
    portfolioId?: string | null;
    offeringId?: string | null;
    operatorId?: string | null;
    version?: string | null;
    tags?: Array<{
      __typename?: 'FileTags';
      extra?: string | null;
      value?: string | null;
      type?: FileTagEnum | null;
      hidden?: boolean | null;
      legalEntityId?: string | null;
    }> | null;
    locations?: Array<{
      __typename?: 'FileLocation';
      entityId?: string | null;
      entityType?: FileEntityTypeEnum | null;
      locationInPage?: FileLocationEnum | null;
      locationInnerId?: string | null;
      sortIndex?: number | null;
    }> | null;
  }>;
};

export type ServerFilesPublicInvestorQueryVariables = Exact<{
  input: GetInvestorPublicFileInput;
}>;

export type ServerFilesPublicInvestorQuery = {
  __typename?: 'Query';
  getInvestorPublicFiles: Array<{
    __typename?: 'PublicFile';
    id: string;
    fileName?: string | null;
    content?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    thumbnail?: string | null;
    shared?: boolean | null;
    status?: string | null;
    size?: number | null;
    url?: string | null;
    projectId?: string | null;
    fundId?: string | null;
    portfolioId?: string | null;
    offeringId?: string | null;
    operatorId?: string | null;
    version?: string | null;
    tags?: Array<{
      __typename?: 'FileTags';
      extra?: string | null;
      value?: string | null;
      type?: FileTagEnum | null;
      hidden?: boolean | null;
      legalEntityId?: string | null;
    }> | null;
    locations?: Array<{
      __typename?: 'FileLocation';
      entityId?: string | null;
      entityType?: FileEntityTypeEnum | null;
      locationInPage?: FileLocationEnum | null;
      locationInnerId?: string | null;
      sortIndex?: number | null;
    }> | null;
  }>;
};

export type ServerFilesPublicProjectFundInvestorQueryVariables = Exact<{
  input: GetInvestorPublicProjectFundFileInput;
}>;

export type ServerFilesPublicProjectFundInvestorQuery = {
  __typename?: 'Query';
  getInvestorProjectsFundsFiles: Array<{
    __typename?: 'PublicFile';
    id: string;
    fileName?: string | null;
    content?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    thumbnail?: string | null;
    shared?: boolean | null;
    status?: string | null;
    size?: number | null;
    url?: string | null;
    projectId?: string | null;
    fundId?: string | null;
    portfolioId?: string | null;
    offeringId?: string | null;
    operatorId?: string | null;
    version?: string | null;
    tags?: Array<{
      __typename?: 'FileTags';
      extra?: string | null;
      value?: string | null;
      type?: FileTagEnum | null;
      hidden?: boolean | null;
      legalEntityId?: string | null;
    }> | null;
    locations?: Array<{
      __typename?: 'FileLocation';
      entityId?: string | null;
      entityType?: FileEntityTypeEnum | null;
      locationInPage?: FileLocationEnum | null;
      locationInnerId?: string | null;
      sortIndex?: number | null;
    }> | null;
  }>;
};

export type GetOperatorInvestorByEmailQueryVariables = Exact<{
  operatorId: Scalars['String'];
  emailSearch: Scalars['String'];
}>;

export type GetOperatorInvestorByEmailQuery = {
  __typename?: 'Query';
  findOperatorInvestorByEmail?: {
    __typename?: 'UserObject';
    id: string;
    email: string;
    userLegalEntities: Array<{
      __typename: 'UserLegalEntity';
      operatorId: string;
      id: string;
      endDate?: string | null;
      startDate: string;
      name: string;
      uniqueId: string;
      viewerIDs: Array<string>;
      investorIDs: Array<string>;
      viewers: Array<{ __typename?: 'UserObject'; id: string; email: string }>;
      investors: Array<{
        __typename?: 'UserObject';
        id: string;
        email: string;
        userLegalEntities: Array<{ __typename?: 'UserLegalEntity'; id: string }>;
      }>;
      pendingTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
      approvedTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
      pendingAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
      approvedAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
      approvedBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
      pendingBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
      userPreferences?: {
        __typename: 'UserPreference';
        id: string;
        startDate: string;
        endDate?: string | null;
        investmentAmount?: InvestmentAmountPreference | null;
        currency: Array<Currency>;
        investmentStructure: Array<InvestmentStructurePreference>;
        investmentType: Array<InvestmentTypePreference>;
        isSuggestedByOperator: boolean;
        riskReward: Array<RiskRewardPreference>;
        strategyType: Array<StrategyTypePreference>;
        userLegalEntityId: string;
        customAnswers: Array<{
          __typename: 'CustomAnswer';
          questionID: string;
          selectedAnswers: Array<string>;
          question: { __typename?: 'UserPreferenceQuestion'; question: string };
        }>;
      } | null;
      suggestedUserPreferences?: {
        __typename: 'UserPreference';
        id: string;
        startDate: string;
        endDate?: string | null;
        investmentAmount?: InvestmentAmountPreference | null;
        currency: Array<Currency>;
        investmentStructure: Array<InvestmentStructurePreference>;
        investmentType: Array<InvestmentTypePreference>;
        isSuggestedByOperator: boolean;
        riskReward: Array<RiskRewardPreference>;
        strategyType: Array<StrategyTypePreference>;
        userLegalEntityId: string;
        customAnswers: Array<{
          __typename: 'CustomAnswer';
          questionID: string;
          selectedAnswers: Array<string>;
          question: { __typename?: 'UserPreferenceQuestion'; question: string };
        }>;
      } | null;
      investments: Array<{
        __typename?: 'Investment';
        id: string;
        entityStatus: ProjectPublish;
        amount?: number | null;
        email: Array<string>;
        percentage?: number | null;
        period?: number | null;
        exitDate?: string | null;
        isContribution?: boolean | null;
        type: InvestmentType;
        date?: string | null;
        investedBy: string;
        commitment?: number | null;
        legalEntityId: string;
        sequenceId?: number | null;
        operatorId: string;
        version?: number | null;
        customizedStatistics?: Array<{
          __typename?: 'StatisticsKeyValue';
          key?: string | null;
          value?: string | null;
        }> | null;
        ref: Array<{ __typename?: 'InvestmentRefObject'; key: InvestmentRef; value: string }>;
        holdings?: Array<{
          __typename?: 'InvestmentHoldingObject';
          date?: string | null;
          value?: string | null;
        }> | null;
        manualHoldings?: Array<{
          __typename?: 'InvestmentHoldingObject';
          date?: string | null;
          value?: string | null;
        }> | null;
        projectDetails?: {
          __typename?: 'OperatorProject';
          id: string;
          category?: ProjectCategory | null;
          customCategory?: string | null;
          currency?: Currency | null;
          operatorId: string;
          status?: ProjectStatus | null;
          calculationType?: CalculationType | null;
          inceptionDate?: string | null;
          closingDate?: string | null;
          kpis?: Array<string> | null;
          name?: string | null;
          description?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          portfolio?: Array<{
            __typename?: 'ProjectPortfolioDataObject';
            key?: string | null;
            value?: string | null;
          }> | null;
          location?: {
            __typename?: 'ProjectLocationObject';
            address?: string | null;
            latitude?: number | null;
            longitude?: number | null;
          } | null;
          updatesDetails?: Array<{
            __typename?: 'Updates';
            reportDate?: string | null;
            progress?: number | null;
            status?: string | null;
            id: string;
            displayTimeline?: boolean | null;
            description?: {
              __typename?: 'MultiLanguage';
              en?: string | null;
              heb?: string | null;
            } | null;
            title?: {
              __typename?: 'MultiLanguage';
              en?: string | null;
              heb?: string | null;
            } | null;
          }> | null;
          properties?: Array<{
            __typename?: 'ProjectPropertyObject';
            key: ProjectProperty;
            series1Legend?: {
              __typename?: 'MultiLanguage';
              en?: string | null;
              heb?: string | null;
            } | null;
            series2Legend?: {
              __typename?: 'MultiLanguage';
              en?: string | null;
              heb?: string | null;
            } | null;
            value: Array<{
              __typename?: 'ProjectPropertyDataObject';
              date?: string | null;
              value?: number | null;
              projected?: number | null;
              title?: string | null;
              annotation?: string | null;
            }>;
          }> | null;
          investmentClasses?: Array<{
            __typename?: 'ProjectInvestmentClassesObject';
            name: string;
            type?: InvestmentClassEnum | null;
            distributionPeriod?: string | null;
            percentage?: number | null;
            allocationAmount?: number | null;
            currency?: Currency | null;
            endDate?: string | null;
            extensionOptionDate?: string | null;
            isCompounding?: boolean | null;
          }> | null;
        } | null;
        fundDetails?: {
          __typename?: 'Fund';
          id: string;
          name?: string | null;
          currency?: Currency | null;
          operatorId: string;
          status?: ProjectStatus | null;
          inceptionDate?: string | null;
          description?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          portfolio?: Array<{
            __typename?: 'FundPortfolioDataObject';
            key?: string | null;
            value?: string | null;
            group?: string | null;
          }> | null;
          projectDetails?: Array<{
            __typename?: 'FundProject';
            category?: ProjectCategory | null;
            customCategory?: string | null;
            name?: string | null;
            fundId: string;
            operatorId?: string | null;
            id: string;
            description?: {
              __typename?: 'MultiLanguage';
              en?: string | null;
              heb?: string | null;
            } | null;
            portfolio?: Array<{
              __typename?: 'ProjectPortfolioDataObject';
              key?: string | null;
              value?: string | null;
            }> | null;
            location?: {
              __typename?: 'ProjectLocationObject';
              address?: string | null;
              latitude?: number | null;
              longitude?: number | null;
            } | null;
          }> | null;
          updatesDetails?: Array<{
            __typename?: 'Updates';
            reportDate?: string | null;
            progress?: number | null;
            status?: string | null;
            id: string;
            displayTimeline?: boolean | null;
            description?: {
              __typename?: 'MultiLanguage';
              en?: string | null;
              heb?: string | null;
            } | null;
            title?: {
              __typename?: 'MultiLanguage';
              en?: string | null;
              heb?: string | null;
            } | null;
          }> | null;
          properties?: Array<{
            __typename?: 'ProjectPropertyObject';
            key: ProjectProperty;
            series1Legend?: {
              __typename?: 'MultiLanguage';
              en?: string | null;
              heb?: string | null;
            } | null;
            series2Legend?: {
              __typename?: 'MultiLanguage';
              en?: string | null;
              heb?: string | null;
            } | null;
            value: Array<{
              __typename?: 'ProjectPropertyDataObject';
              date?: string | null;
              value?: number | null;
              projected?: number | null;
              title?: string | null;
              annotation?: string | null;
            }>;
          }> | null;
          investmentClasses?: Array<{
            __typename?: 'ProjectInvestmentClassesObject';
            name: string;
            type?: InvestmentClassEnum | null;
            distributionPeriod?: string | null;
            percentage?: number | null;
            allocationAmount?: number | null;
            currency?: Currency | null;
            endDate?: string | null;
            extensionOptionDate?: string | null;
            isCompounding?: boolean | null;
          }> | null;
        } | null;
        distributions?: Array<{
          __typename?: 'InvestmentDistributionsObject';
          investmentClassType?: InvestmentClassEnum | null;
          date?: string | null;
          payDueDate?: string | null;
          amount?: number | null;
          currency?: Currency | null;
          currencyRate?: number | null;
          override?: boolean | null;
          expenses?: number | null;
          notes?: string | null;
          paymentComponent?: PaymentComponentEnum | null;
          distributionPeriod?: string | null;
        }> | null;
        contributions?: Array<{
          __typename?: 'InvestmentContributionsObject';
          date?: string | null;
          closingDate?: string | null;
          contribution?: number | null;
          commitment?: number | null;
          capitalCall?: number | null;
          currency?: Currency | null;
          currencyRate?: number | null;
          percentage?: number | null;
          override?: boolean | null;
          investmentClassName?: string | null;
          notes?: string | null;
        }> | null;
        description?: {
          __typename?: 'MultiLanguage';
          en?: string | null;
          heb?: string | null;
        } | null;
      }>;
    }>;
  } | null;
};

export type GetOperatorInvestorByEmailViewAsQueryVariables = Exact<{
  operatorId: Scalars['String'];
  emailSearch: Scalars['String'];
}>;

export type GetOperatorInvestorByEmailViewAsQuery = {
  __typename?: 'Query';
  findOperatorInvestorByEmail?: {
    __typename?: 'UserObject';
    id: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    userLegalEntities: Array<{
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      investorIDs: Array<string>;
      deceased?: boolean | null;
      viewerIDs: Array<string>;
      operatorId: string;
      uniqueId: string;
      approvedTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
      pendingTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
      approvedAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
      pendingAccreditationInfo?: {
        __typename: 'AccreditationInfo';
        id: string;
        endDate?: string | null;
        accreditationType: AccreditationType;
        startDate: string;
        status: InformationStatus;
        country: string;
        expirationDate?: string | null;
      } | null;
      approvedBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
      pendingBankAccounts: Array<{
        __typename: 'BankAccount';
        id: string;
        accountName?: string | null;
        isActive: boolean;
        notes?: string | null;
        startDate: string;
        status: InformationStatus;
        accountNumber?: string | null;
        approvedBankAccountId?: string | null;
        bankName?: string | null;
        currencies?: Array<string> | null;
        IBAN?: string | null;
        swift?: string | null;
        routingNumber?: string | null;
        benificiaryAddress?: string | null;
        branchAddress?: string | null;
        branchNumber?: string | null;
        endDate?: string | null;
      }>;
      userPreferences?: {
        __typename: 'UserPreference';
        id: string;
        startDate: string;
        endDate?: string | null;
        investmentAmount?: InvestmentAmountPreference | null;
        currency: Array<Currency>;
        investmentStructure: Array<InvestmentStructurePreference>;
        investmentType: Array<InvestmentTypePreference>;
        isSuggestedByOperator: boolean;
        riskReward: Array<RiskRewardPreference>;
        strategyType: Array<StrategyTypePreference>;
        userLegalEntityId: string;
        customAnswers: Array<{
          __typename: 'CustomAnswer';
          questionID: string;
          selectedAnswers: Array<string>;
          question: { __typename?: 'UserPreferenceQuestion'; question: string };
        }>;
      } | null;
      suggestedUserPreferences?: {
        __typename: 'UserPreference';
        id: string;
        startDate: string;
        endDate?: string | null;
        investmentAmount?: InvestmentAmountPreference | null;
        currency: Array<Currency>;
        investmentStructure: Array<InvestmentStructurePreference>;
        investmentType: Array<InvestmentTypePreference>;
        isSuggestedByOperator: boolean;
        riskReward: Array<RiskRewardPreference>;
        strategyType: Array<StrategyTypePreference>;
        userLegalEntityId: string;
        customAnswers: Array<{
          __typename: 'CustomAnswer';
          questionID: string;
          selectedAnswers: Array<string>;
          question: { __typename?: 'UserPreferenceQuestion'; question: string };
        }>;
      } | null;
      userPreferenceCustomQuestions: Array<{
        __typename?: 'UserPreferenceQuestion';
        id: string;
        question: string;
        answers: Array<{ __typename?: 'UserPreferenceAnswer'; description: string; key: string }>;
      }>;
    }>;
    investmentDetails?: Array<{
      __typename?: 'Investment';
      amount?: number | null;
      legalEntityId: string;
      email: Array<string>;
      percentage?: number | null;
      period?: number | null;
      exitDate?: string | null;
      isContribution?: boolean | null;
      type: InvestmentType;
      id: string;
      date?: string | null;
      investedBy: string;
      commitment?: number | null;
      netRoi?: number | null;
      grossRoi?: number | null;
      netIrr?: number | null;
      grossIrr?: number | null;
      netCoc?: number | null;
      grossCoc?: number | null;
      sequenceId?: number | null;
      operatorId: string;
      version?: number | null;
      customizedStatistics?: Array<{
        __typename?: 'StatisticsKeyValue';
        key?: string | null;
        value?: string | null;
      }> | null;
      ref: Array<{ __typename?: 'InvestmentRefObject'; key: InvestmentRef; value: string }>;
      holdings?: Array<{
        __typename?: 'InvestmentHoldingObject';
        date?: string | null;
        value?: string | null;
      }> | null;
      manualHoldings?: Array<{
        __typename?: 'InvestmentHoldingObject';
        date?: string | null;
        value?: string | null;
      }> | null;
      projectDetails?: {
        __typename?: 'OperatorProject';
        id: string;
        category?: ProjectCategory | null;
        customCategory?: string | null;
        currency?: Currency | null;
        operatorId: string;
        status?: ProjectStatus | null;
        calculationType?: CalculationType | null;
        inceptionDate?: string | null;
        closingDate?: string | null;
        kpis?: Array<string> | null;
        name?: string | null;
        description?: {
          __typename?: 'MultiLanguage';
          en?: string | null;
          heb?: string | null;
        } | null;
        portfolio?: Array<{
          __typename?: 'ProjectPortfolioDataObject';
          key?: string | null;
          value?: string | null;
        }> | null;
        location?: {
          __typename?: 'ProjectLocationObject';
          address?: string | null;
          latitude?: number | null;
          longitude?: number | null;
        } | null;
        updatesDetails?: Array<{
          __typename?: 'Updates';
          reportDate?: string | null;
          progress?: number | null;
          status?: string | null;
          id: string;
          displayTimeline?: boolean | null;
          description?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          title?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
        }> | null;
        properties?: Array<{
          __typename?: 'ProjectPropertyObject';
          key: ProjectProperty;
          series1Legend?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          series2Legend?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          value: Array<{
            __typename?: 'ProjectPropertyDataObject';
            date?: string | null;
            value?: number | null;
            projected?: number | null;
            title?: string | null;
            annotation?: string | null;
          }>;
        }> | null;
        investmentClasses?: Array<{
          __typename?: 'ProjectInvestmentClassesObject';
          name: string;
          type?: InvestmentClassEnum | null;
          distributionPeriod?: string | null;
          percentage?: number | null;
          allocationAmount?: number | null;
          currency?: Currency | null;
          endDate?: string | null;
          extensionOptionDate?: string | null;
          isCompounding?: boolean | null;
        }> | null;
      } | null;
      fundDetails?: {
        __typename?: 'Fund';
        id: string;
        name?: string | null;
        currency?: Currency | null;
        operatorId: string;
        status?: ProjectStatus | null;
        inceptionDate?: string | null;
        description?: {
          __typename?: 'MultiLanguage';
          en?: string | null;
          heb?: string | null;
        } | null;
        portfolio?: Array<{
          __typename?: 'FundPortfolioDataObject';
          key?: string | null;
          value?: string | null;
          group?: string | null;
        }> | null;
        projectDetails?: Array<{
          __typename?: 'FundProject';
          category?: ProjectCategory | null;
          customCategory?: string | null;
          name?: string | null;
          fundId: string;
          operatorId?: string | null;
          id: string;
          description?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          portfolio?: Array<{
            __typename?: 'ProjectPortfolioDataObject';
            key?: string | null;
            value?: string | null;
          }> | null;
          location?: {
            __typename?: 'ProjectLocationObject';
            address?: string | null;
            latitude?: number | null;
            longitude?: number | null;
          } | null;
        }> | null;
        updatesDetails?: Array<{
          __typename?: 'Updates';
          reportDate?: string | null;
          progress?: number | null;
          status?: string | null;
          id: string;
          displayTimeline?: boolean | null;
          description?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          title?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
        }> | null;
        properties?: Array<{
          __typename?: 'ProjectPropertyObject';
          key: ProjectProperty;
          series1Legend?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          series2Legend?: {
            __typename?: 'MultiLanguage';
            en?: string | null;
            heb?: string | null;
          } | null;
          value: Array<{
            __typename?: 'ProjectPropertyDataObject';
            date?: string | null;
            value?: number | null;
            projected?: number | null;
            title?: string | null;
            annotation?: string | null;
          }>;
        }> | null;
        investmentClasses?: Array<{
          __typename?: 'ProjectInvestmentClassesObject';
          name: string;
          type?: InvestmentClassEnum | null;
          distributionPeriod?: string | null;
          percentage?: number | null;
          allocationAmount?: number | null;
          currency?: Currency | null;
          endDate?: string | null;
          extensionOptionDate?: string | null;
          isCompounding?: boolean | null;
        }> | null;
      } | null;
      distributions?: Array<{
        __typename?: 'InvestmentDistributionsObject';
        investmentClassType?: InvestmentClassEnum | null;
        date?: string | null;
        payDueDate?: string | null;
        amount?: number | null;
        currency?: Currency | null;
        currencyRate?: number | null;
        override?: boolean | null;
        expenses?: number | null;
        notes?: string | null;
        paymentComponent?: PaymentComponentEnum | null;
        distributionPeriod?: string | null;
      }> | null;
      contributions?: Array<{
        __typename?: 'InvestmentContributionsObject';
        date?: string | null;
        closingDate?: string | null;
        contribution?: number | null;
        commitment?: number | null;
        capitalCall?: number | null;
        currency?: Currency | null;
        currencyRate?: number | null;
        percentage?: number | null;
        override?: boolean | null;
        investmentClassName?: string | null;
        notes?: string | null;
      }> | null;
      description?: {
        __typename?: 'MultiLanguage';
        en?: string | null;
        heb?: string | null;
      } | null;
    }> | null;
  } | null;
};

export type GetOperatorInvestorListQueryVariables = Exact<{
  operatorId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
}>;

export type GetOperatorInvestorListQuery = {
  __typename?: 'Query';
  findOperatorInvestorsList: Array<{
    __typename?: 'UserObject';
    id: string;
    email: string;
    userLegalEntities: Array<{
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      operatorId: string;
      investorIDs: Array<string>;
      managerIDs: Array<string>;
      uniqueId: string;
      deceased?: boolean | null;
      viewers: Array<{ __typename?: 'UserObject'; id: string; email: string }>;
      investors: Array<{ __typename?: 'UserObject'; id: string; email: string }>;
    }>;
  }>;
};

export type GetUserAdminQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserAdminQuery = {
  __typename?: 'Query';
  findCurrentUser?: {
    __typename?: 'UserObject';
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    email: string;
    role: UserRoles;
    adminType?: AdminType | null;
    settings?: {
      __typename?: 'UserSettingsObject';
      marketing?: boolean | null;
      terms?: boolean | null;
      use_mfa?: boolean | null;
    } | null;
    operatorDetails?: Array<{
      __typename?: 'Operator';
      id: string;
      name?: string | null;
      websiteUrl?: string | null;
      userPreferenceQuestions: Array<{
        __typename?: 'UserPreferenceQuestion';
        id: string;
        endDate?: string | null;
        question: string;
        answers: Array<{ __typename?: 'UserPreferenceAnswer'; description: string; key: string }>;
      }>;
      description?: {
        __typename?: 'MultiLanguage';
        en?: string | null;
        heb?: string | null;
      } | null;
      layout?: Array<{
        __typename?: 'LayoutDataObject';
        key?: Layout | null;
        value?: Array<string> | null;
      }> | null;
      offerDetails?: Array<{
        __typename?: 'Offer';
        category?: ProjectCategory | null;
        customCategory?: string | null;
        strategy?: string | null;
        offerStartDate?: string | null;
        id: string;
        name?: string | null;
        operatorId: string;
        kpis?: Array<{
          __typename?: 'OfferKpiObject';
          key?: string | null;
          value?: string | null;
        }> | null;
        description?: {
          __typename?: 'MultiLanguage';
          en?: string | null;
          heb?: string | null;
        } | null;
        location?: {
          __typename?: 'ProjectLocationObject';
          address?: string | null;
          latitude?: number | null;
          longitude?: number | null;
        } | null;
        audience?: Array<{
          __typename?: 'ProspectObject';
          email: string;
          role: UserRoles;
          firstName?: string | null;
          lastName?: string | null;
          language?: Language | null;
        }> | null;
      }> | null;
      contacts?: Array<{
        __typename?: 'OperatorContactsObject';
        fax?: string | null;
        main?: boolean | null;
        phone?: string | null;
        email?: string | null;
        name?: string | null;
        mobile?: string | null;
      }> | null;
      updatesDetails?: Array<{
        __typename?: 'Updates';
        reportDate?: string | null;
        progress?: number | null;
        status?: string | null;
        id: string;
        displayTimeline?: boolean | null;
        description?: {
          __typename?: 'MultiLanguage';
          en?: string | null;
          heb?: string | null;
        } | null;
        title?: { __typename?: 'MultiLanguage'; en?: string | null; heb?: string | null } | null;
      }> | null;
      fundDetails?: Array<{
        __typename?: 'Fund';
        inceptionDate?: string | null;
        closingDate?: string | null;
        id: string;
        name?: string | null;
        operatorId: string;
        status?: ProjectStatus | null;
      }> | null;
      projectDetails?: Array<{
        __typename?: 'OperatorProject';
        id: string;
        operatorId: string;
        status?: ProjectStatus | null;
        name?: string | null;
        kpis?: Array<string> | null;
      }> | null;
    }> | null;
  } | null;
};

export type GetUnreadNotificationsNumberQueryVariables = Exact<{
  relatedId: Scalars['String'];
}>;

export type GetUnreadNotificationsNumberQuery = {
  __typename?: 'Query';
  getUnreadNotificationsNumber: number;
};

export type GetUserNotificationsQueryVariables = Exact<{
  relatedId: Scalars['String'];
  latest: Scalars['String'];
}>;

export type GetUserNotificationsQuery = {
  __typename?: 'Query';
  getUserNotifications: Array<{
    __typename?: 'Notifications';
    operatorId?: string | null;
    status?: NotificationStatus | null;
    subject?: string | null;
    templateId?: string | null;
    messageId?: string | null;
    reason?: string | null;
    sendId?: string | null;
    projectId?: string | null;
    fundId?: string | null;
    id?: string | null;
    date?: string | null;
    personal?: boolean | null;
    to?: Array<{ __typename?: 'Recipient'; email?: string | null; name?: string | null }> | null;
    templateParams?: {
      __typename?: 'TemplateData';
      project_fund_name?: string | null;
      message_text?: string | null;
      operator_name?: string | null;
      message?: string | null;
      project_name?: string | null;
      operator_logo?: string | null;
      operator_url?: string | null;
      offering_name?: string | null;
      offering_id?: string | null;
    } | null;
  }>;
};

export type MarkAsReadMutationVariables = Exact<{
  notificationId: Scalars['String'];
}>;

export type MarkAsReadMutation = { __typename?: 'Mutation'; markAsRead: string };

export type CreateTaxInfoMutationVariables = Exact<{
  input: CreateTaxInfoInput;
}>;

export type CreateTaxInfoMutation = {
  __typename?: 'Mutation';
  createTaxInfo: {
    __typename?: 'TaxInfo';
    id: string;
    userLegalEntity: {
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      approvedTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
      pendingTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
    };
  };
};

export type GetTaxInfoQueryVariables = Exact<{
  investorID: Scalars['String'];
}>;

export type GetTaxInfoQuery = {
  __typename?: 'Query';
  findInvestorUser: {
    __typename?: 'UserObject';
    id: string;
    userLegalEntities: Array<{
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      operatorId: string;
      approvedTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
      pendingTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
    }>;
  };
};

export type RequestTaxInfoApprovalMutationVariables = Exact<{
  input: RequestTaxInfoApprovalInput;
}>;

export type RequestTaxInfoApprovalMutation = {
  __typename?: 'Mutation';
  requestTaxInfoApproval: {
    __typename?: 'TaxInfo';
    id: string;
    userLegalEntity: {
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      approvedTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
      pendingTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
    };
  };
};

export type RequestTaxInfoChangesMutationVariables = Exact<{
  input: RequestTaxInfoChangesInput;
}>;

export type RequestTaxInfoChangesMutation = {
  __typename?: 'Mutation';
  requestTaxInfoChanges: {
    __typename?: 'TaxInfo';
    id: string;
    userLegalEntity: {
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      approvedTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
      pendingTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
    };
  };
};

export type UpdateTaxInfoMutationVariables = Exact<{
  input: UpdateTaxInfoInput;
}>;

export type UpdateTaxInfoMutation = {
  __typename?: 'Mutation';
  updateTaxInfo: {
    __typename?: 'TaxInfo';
    id: string;
    userLegalEntity: {
      __typename?: 'UserLegalEntity';
      id: string;
      name: string;
      approvedTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
      pendingTaxInfo?: {
        __typename: 'TaxInfo';
        id: string;
        address?: string | null;
        endDate?: string | null;
        notes?: string | null;
        SSN?: string | null;
        startDate: string;
        status: InformationStatus;
        TIN?: string | null;
      } | null;
    };
  };
};
